// src/components/BlockToolbar/BlockToolbar.tsx
import "react";
import {
  Toolbar as RACToolbar
} from "react-aria-components";
import { jsx } from "react/jsx-runtime";
function BlockToolbar(props) {
  return /* @__PURE__ */ jsx(RACToolbar, { ...props, className: "blocks-toolbar" });
}

// src/components/Breadcrumbs/Breadcrumbs.tsx
import "react";
import {
  Breadcrumbs as RACBreadcrumbs,
  Breadcrumb as RACBreadcrumb
} from "react-aria-components";

// src/components/Link/Link.tsx
import { Link } from "react-aria-components";

// src/components/Breadcrumbs/HomeIcon.tsx
import "react";

// src/components/Icon/Icon.tsx
import React2 from "react";
import {
  baseStyleProps,
  useSlotProps,
  useStyleProps
} from "@react-spectrum/utils";
import { filterDOMProps } from "@react-aria/utils";
import _clsx from "clsx";
function iconColorValue(value) {
  return `var(--quanta-color-icon-${value})`;
}
var iconStyleProps = {
  ...baseStyleProps,
  color: ["color", iconColorValue]
};
function Icon(props) {
  props = useSlotProps(props, "icon");
  let {
    children,
    size,
    "aria-label": ariaLabel,
    "aria-hidden": ariaHidden,
    ...otherProps
  } = props;
  let { styleProps } = useStyleProps(otherProps, iconStyleProps);
  if (!ariaHidden) {
    ariaHidden = void 0;
  }
  let iconSize = size ? size : "M";
  return React2.cloneElement(children, {
    ...filterDOMProps(otherProps),
    ...styleProps,
    focusable: "false",
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel ? ariaHidden || void 0 : true,
    role: "img",
    className: _clsx(
      "q icon",
      `icon--size${iconSize}`,
      children.props.className,
      styleProps.className
    )
  });
}

// src/components/Breadcrumbs/HomeIcon.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var HomeIcon = (props) => {
  return /* @__PURE__ */ jsx2(Icon, { ...props, children: /* @__PURE__ */ jsx2(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "home-icon",
      children: /* @__PURE__ */ jsx2(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.5855 9.68946L12 2.7666L2.41455 9.68946L3.58553 11.3108L12 5.23367L20.4146 11.3108L21.5855 9.68946ZM7 12.0001H5V21.0001H11V16.0001H13V21.0001H19V12.0001H17V19.0001H15V14.0001H9V19.0001H7V12.0001Z"
        }
      )
    }
  ) });
};

// src/components/Breadcrumbs/Breadcrumbs.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
function Breadcrumbs({
  className,
  items,
  root,
  includeRoot
}) {
  let itemsWithRoot;
  if (includeRoot) {
    const rootItem = {
      "@id": root || "/",
      title: "Home"
    };
    itemsWithRoot = [rootItem, ...items];
  }
  return /* @__PURE__ */ jsx3("nav", { "aria-label": "breadcrumbs", role: "navigation", children: /* @__PURE__ */ jsx3(RACBreadcrumbs, { className, items: itemsWithRoot || items, children: (item) => /* @__PURE__ */ jsx3(RACBreadcrumb, { id: item["@id"], children: /* @__PURE__ */ jsxs(Link, { href: item["@id"], children: [
    item["@id"] === (root || "/") && /* @__PURE__ */ jsx3(HomeIcon, { size: "S" }),
    item.title
  ] }) }) }) });
}

// src/components/Button/Button.tsx
import { forwardRef } from "react";
import { Button as RACButton } from "react-aria-components";
import { jsx as jsx4 } from "react/jsx-runtime";
var Button = forwardRef(function _Button(props, ref) {
  return /* @__PURE__ */ jsx4(RACButton, { ref, ...props });
});

// src/components/Calendar/Calendar.tsx
import "react";
import {
  Button as Button2,
  Calendar as RACCalendar,
  CalendarCell,
  CalendarGrid,
  Heading,
  Text
} from "react-aria-components";
import { jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
function Calendar({
  errorMessage,
  ...props
}) {
  return /* @__PURE__ */ jsxs2(RACCalendar, { ...props, children: [
    /* @__PURE__ */ jsxs2("header", { children: [
      /* @__PURE__ */ jsx5(Button2, { slot: "previous", children: "\u25C0" }),
      /* @__PURE__ */ jsx5(Heading, {}),
      /* @__PURE__ */ jsx5(Button2, { slot: "next", children: "\u25B6" })
    ] }),
    /* @__PURE__ */ jsx5(CalendarGrid, { children: (date) => /* @__PURE__ */ jsx5(CalendarCell, { date }) }),
    errorMessage && /* @__PURE__ */ jsx5(Text, { slot: "errorMessage", children: errorMessage })
  ] });
}

// src/components/ColorArea/ColorArea.tsx
import "react";
import {
  ColorArea as RACColorArea,
  ColorThumb
} from "react-aria-components";
import { jsx as jsx6 } from "react/jsx-runtime";
function ColorArea(props) {
  return /* @__PURE__ */ jsx6(RACColorArea, { ...props, children: /* @__PURE__ */ jsx6(ColorThumb, {}) });
}

// src/components/ColorField/ColorField.tsx
import "react";
import {
  ColorField as RACColorField,
  FieldError,
  Input,
  Label,
  Text as Text2
} from "react-aria-components";
import { jsx as jsx7, jsxs as jsxs3 } from "react/jsx-runtime";
function ColorField({
  label,
  description,
  errorMessage,
  ...props
}) {
  return /* @__PURE__ */ jsxs3(RACColorField, { ...props, children: [
    label && /* @__PURE__ */ jsx7(Label, { children: label }),
    /* @__PURE__ */ jsx7(Input, {}),
    description && /* @__PURE__ */ jsx7(Text2, { slot: "description", children: description }),
    /* @__PURE__ */ jsx7(FieldError, { children: errorMessage })
  ] });
}

// src/components/ColorPicker/ColorPicker.tsx
import "react";
import {
  Button as Button3,
  ColorPicker as RACColorPicker,
  Dialog,
  DialogTrigger,
  Popover
} from "react-aria-components";

// src/components/ColorSwatch/ColorSwatch.tsx
import "react";
import {
  ColorSwatch as RACColorSwatch
} from "react-aria-components";
import { jsx as jsx8 } from "react/jsx-runtime";
function ColorSwatch(props) {
  return /* @__PURE__ */ jsx8(
    RACColorSwatch,
    {
      ...props,
      style: ({ color }) => ({
        background: `linear-gradient(${color}, ${color}),
          repeating-conic-gradient(#CCC 0% 25%, white 0% 50%) 50% / 16px 16px`
      })
    }
  );
}

// src/components/ColorSlider/ColorSlider.tsx
import "react";
import {
  ColorSlider as RACColorSlider,
  ColorThumb as ColorThumb2,
  Label as Label2,
  SliderOutput,
  SliderTrack
} from "react-aria-components";
import { jsx as jsx9, jsxs as jsxs4 } from "react/jsx-runtime";
function ColorSlider({ label, ...props }) {
  return /* @__PURE__ */ jsxs4(RACColorSlider, { ...props, children: [
    /* @__PURE__ */ jsx9(Label2, { children: label }),
    /* @__PURE__ */ jsx9(SliderOutput, {}),
    /* @__PURE__ */ jsx9(
      SliderTrack,
      {
        style: ({ defaultStyle }) => ({
          background: `${defaultStyle.background},
            repeating-conic-gradient(#CCC 0% 25%, white 0% 50%) 50% / 16px 16px`
        }),
        children: /* @__PURE__ */ jsx9(ColorThumb2, {})
      }
    )
  ] });
}

// src/components/ColorPicker/ColorPicker.tsx
import { Fragment, jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
function ColorPicker({ label, children, ...props }) {
  return /* @__PURE__ */ jsx10(RACColorPicker, { ...props, children: /* @__PURE__ */ jsxs5(DialogTrigger, { children: [
    /* @__PURE__ */ jsxs5(Button3, { className: "color-picker", children: [
      /* @__PURE__ */ jsx10(ColorSwatch, {}),
      /* @__PURE__ */ jsx10("span", { children: label })
    ] }),
    /* @__PURE__ */ jsx10(Popover, { placement: "bottom start", children: /* @__PURE__ */ jsx10(Dialog, { className: "color-picker-dialog", children: children || /* @__PURE__ */ jsxs5(Fragment, { children: [
      /* @__PURE__ */ jsx10(
        ColorArea,
        {
          colorSpace: "hsb",
          xChannel: "saturation",
          yChannel: "brightness"
        }
      ),
      /* @__PURE__ */ jsx10(ColorSlider, { colorSpace: "hsb", channel: "hue" }),
      /* @__PURE__ */ jsx10(ColorField, { label: "Hex" })
    ] }) }) })
  ] }) });
}

// src/components/ColorSwatchPicker/ColorSwatchPicker.tsx
import "react";
import {
  ColorSwatchPicker as AriaColorSwatchPicker,
  ColorSwatchPickerItem as AriaColorSwatchPickerItem
} from "react-aria-components";
import { jsx as jsx11 } from "react/jsx-runtime";
function ColorSwatchPicker({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx11(AriaColorSwatchPicker, { ...props, children });
}

// src/components/ColorWheel/ColorWheel.tsx
import "react";
import {
  ColorThumb as ColorThumb3,
  ColorWheel as AriaColorWheel,
  ColorWheelTrack
} from "react-aria-components";
import { jsx as jsx12, jsxs as jsxs6 } from "react/jsx-runtime";
function ColorWheel(props) {
  return /* @__PURE__ */ jsxs6(AriaColorWheel, { ...props, outerRadius: 100, innerRadius: 74, children: [
    /* @__PURE__ */ jsx12(ColorWheelTrack, {}),
    /* @__PURE__ */ jsx12(ColorThumb3, {})
  ] });
}

// src/components/Checkbox/Checkbox.tsx
import "react";
import {
  Checkbox as RACCheckbox
} from "react-aria-components";
import { Fragment as Fragment2, jsx as jsx13, jsxs as jsxs7 } from "react/jsx-runtime";
function Checkbox({ children, ...props }) {
  return /* @__PURE__ */ jsx13(RACCheckbox, { ...props, children: ({ isIndeterminate }) => /* @__PURE__ */ jsxs7(Fragment2, { children: [
    /* @__PURE__ */ jsx13("div", { className: "checkbox", children: /* @__PURE__ */ jsx13("svg", { viewBox: "0 0 18 18", "aria-hidden": "true", children: isIndeterminate ? /* @__PURE__ */ jsx13("rect", { x: 1, y: 7.5, width: 15, height: 3 }) : /* @__PURE__ */ jsx13("polyline", { points: "1 9 7 14 15 4" }) }) }),
    props.label || children
  ] }) });
}

// src/components/CheckboxField/CheckboxField.tsx
import "react";
import { Text as Text3 } from "react-aria-components";
import { jsx as jsx14, jsxs as jsxs8 } from "react/jsx-runtime";
function CheckboxField({
  children,
  errorMessage,
  description,
  ...props
}) {
  return /* @__PURE__ */ jsxs8("div", { className: "react-aria-CheckboxField", children: [
    /* @__PURE__ */ jsx14(Checkbox, { ...props }),
    description && /* @__PURE__ */ jsx14(Text3, { slot: "description", children: description }),
    props.isInvalid && /* @__PURE__ */ jsx14(Text3, { slot: "errorMessage", children: errorMessage })
  ] });
}

// src/components/CheckboxGroup/CheckboxGroup.tsx
import "react";
import {
  CheckboxGroup as RACCheckboxGroup,
  FieldError as FieldError2,
  Text as Text4
} from "react-aria-components";
import { jsx as jsx15, jsxs as jsxs9 } from "react/jsx-runtime";
function CheckboxGroup({
  label,
  description,
  errorMessage,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsxs9(RACCheckboxGroup, { ...props, children: [
    label,
    children,
    description && /* @__PURE__ */ jsx15(Text4, { slot: "description", children: description }),
    /* @__PURE__ */ jsx15(FieldError2, { children: errorMessage })
  ] });
}

// src/components/ComboBox/ComboBox.tsx
import "react";
import {
  Button as Button4,
  ComboBox as RACComboBox,
  FieldError as FieldError3,
  Input as Input2,
  Label as Label3,
  ListBox,
  ListBoxItem,
  Popover as Popover2,
  Text as Text5
} from "react-aria-components";
import { jsx as jsx16, jsxs as jsxs10 } from "react/jsx-runtime";
function ComboBox({
  label,
  description,
  errorMessage,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsxs10(RACComboBox, { ...props, children: [
    /* @__PURE__ */ jsx16(Label3, { children: label }),
    /* @__PURE__ */ jsxs10("div", { className: "my-combobox-container", children: [
      /* @__PURE__ */ jsx16(Input2, {}),
      /* @__PURE__ */ jsx16(Button4, { children: "\u25BC" })
    ] }),
    description && /* @__PURE__ */ jsx16(Text5, { slot: "description", children: description }),
    /* @__PURE__ */ jsx16(FieldError3, { children: errorMessage }),
    /* @__PURE__ */ jsx16(Popover2, { children: /* @__PURE__ */ jsx16(ListBox, { children }) })
  ] });
}
function ComboBoxItem(props) {
  return /* @__PURE__ */ jsx16(ListBoxItem, { ...props });
}

// src/components/Container/Container.tsx
import "react";
import cx from "clsx";
import { jsx as jsx17 } from "react/jsx-runtime";
var Container = (props) => {
  const {
    as: Component = "div",
    children,
    className,
    layout,
    narrow,
    ...rest
  } = props;
  const classes = cx("q", "container", className, { layout, narrow });
  return /* @__PURE__ */ jsx17(Component, { ...rest, className: classes, children });
};

// src/components/DateField/DateField.tsx
import "react";
import {
  DateField as RACDateField,
  DateInput,
  DateSegment,
  FieldError as FieldError4,
  Label as Label4,
  Text as Text6
} from "react-aria-components";
import { jsx as jsx18, jsxs as jsxs11 } from "react/jsx-runtime";
function DateField({
  label,
  description,
  errorMessage,
  ...props
}) {
  return /* @__PURE__ */ jsxs11(RACDateField, { ...props, children: [
    /* @__PURE__ */ jsx18(Label4, { children: label }),
    /* @__PURE__ */ jsx18(DateInput, { children: (segment) => /* @__PURE__ */ jsx18(DateSegment, { segment }) }),
    description && /* @__PURE__ */ jsx18(Text6, { slot: "description", children: description }),
    /* @__PURE__ */ jsx18(FieldError4, { children: errorMessage })
  ] });
}

// src/components/DatePicker/DatePicker.tsx
import "react";
import {
  Button as Button5,
  Calendar as Calendar2,
  CalendarCell as CalendarCell2,
  CalendarGrid as CalendarGrid2,
  DateInput as DateInput2,
  DatePicker as RACDatePicker,
  DateSegment as DateSegment2,
  Dialog as Dialog2,
  FieldError as FieldError5,
  Group,
  Heading as Heading2,
  Label as Label5,
  Popover as Popover3,
  Text as Text7
} from "react-aria-components";
import { jsx as jsx19, jsxs as jsxs12 } from "react/jsx-runtime";
function DatePicker({
  label,
  description,
  errorMessage,
  ...props
}) {
  return /* @__PURE__ */ jsxs12(RACDatePicker, { ...props, children: [
    /* @__PURE__ */ jsx19(Label5, { children: label }),
    /* @__PURE__ */ jsxs12(Group, { children: [
      /* @__PURE__ */ jsx19(DateInput2, { children: (segment) => /* @__PURE__ */ jsx19(DateSegment2, { segment }) }),
      /* @__PURE__ */ jsx19(Button5, { children: "\u25BC" })
    ] }),
    description && /* @__PURE__ */ jsx19(Text7, { slot: "description", children: description }),
    /* @__PURE__ */ jsx19(FieldError5, { children: errorMessage }),
    /* @__PURE__ */ jsx19(Popover3, { children: /* @__PURE__ */ jsx19(Dialog2, { children: /* @__PURE__ */ jsxs12(Calendar2, { children: [
      /* @__PURE__ */ jsxs12("header", { children: [
        /* @__PURE__ */ jsx19(Button5, { slot: "previous", children: "\u25C0" }),
        /* @__PURE__ */ jsx19(Heading2, {}),
        /* @__PURE__ */ jsx19(Button5, { slot: "next", children: "\u25B6" })
      ] }),
      /* @__PURE__ */ jsx19(CalendarGrid2, { children: (date) => /* @__PURE__ */ jsx19(CalendarCell2, { date }) })
    ] }) }) })
  ] });
}

// src/components/DateRangePicker/DateRangePicker.tsx
import "react";
import {
  Button as Button6,
  CalendarCell as CalendarCell3,
  CalendarGrid as CalendarGrid3,
  DateInput as DateInput3,
  DateRangePicker as RACDateRangePicker,
  DateSegment as DateSegment3,
  Dialog as Dialog3,
  FieldError as FieldError6,
  Group as Group2,
  Heading as Heading3,
  Label as Label6,
  Popover as Popover4,
  RangeCalendar,
  Text as Text8
} from "react-aria-components";
import { jsx as jsx20, jsxs as jsxs13 } from "react/jsx-runtime";
function DateRangePicker({
  label,
  description,
  errorMessage,
  ...props
}) {
  return /* @__PURE__ */ jsxs13(RACDateRangePicker, { ...props, children: [
    /* @__PURE__ */ jsx20(Label6, { children: label }),
    /* @__PURE__ */ jsxs13(Group2, { children: [
      /* @__PURE__ */ jsx20(DateInput3, { slot: "start", children: (segment) => /* @__PURE__ */ jsx20(DateSegment3, { segment }) }),
      /* @__PURE__ */ jsx20("span", { "aria-hidden": "true", children: "\u2013" }),
      /* @__PURE__ */ jsx20(DateInput3, { slot: "end", children: (segment) => /* @__PURE__ */ jsx20(DateSegment3, { segment }) }),
      /* @__PURE__ */ jsx20(Button6, { children: "\u25BC" })
    ] }),
    description && /* @__PURE__ */ jsx20(Text8, { slot: "description", children: description }),
    /* @__PURE__ */ jsx20(FieldError6, { children: errorMessage }),
    /* @__PURE__ */ jsx20(Popover4, { children: /* @__PURE__ */ jsx20(Dialog3, { children: /* @__PURE__ */ jsxs13(RangeCalendar, { children: [
      /* @__PURE__ */ jsxs13("header", { children: [
        /* @__PURE__ */ jsx20(Button6, { slot: "previous", children: "\u25C0" }),
        /* @__PURE__ */ jsx20(Heading3, {}),
        /* @__PURE__ */ jsx20(Button6, { slot: "next", children: "\u25B6" })
      ] }),
      /* @__PURE__ */ jsx20(CalendarGrid3, { children: (date) => /* @__PURE__ */ jsx20(CalendarCell3, { date }) })
    ] }) }) })
  ] });
}

// src/components/Dialog/Dialog.tsx
import "react";
import { Dialog as RACDialog } from "react-aria-components";
import { jsx as jsx21 } from "react/jsx-runtime";
function Dialog4(props) {
  return /* @__PURE__ */ jsx21(RACDialog, { ...props });
}

// src/components/Disclosure/Disclosure.tsx
import "react";
import {
  UNSTABLE_Disclosure as RACDisclosure
} from "react-aria-components";
import { jsx as jsx22 } from "react/jsx-runtime";
function Disclosure(props) {
  return /* @__PURE__ */ jsx22(RACDisclosure, { ...props });
}

// src/components/DisclosureGroup/DisclosureGroup.tsx
import "react";
import {
  UNSTABLE_DisclosureGroup as RACDisclosureGroup
} from "react-aria-components";
import { jsx as jsx23 } from "react/jsx-runtime";
function DisclosureGroup(props) {
  return /* @__PURE__ */ jsx23(RACDisclosureGroup, { ...props });
}

// src/components/Form/Form.tsx
import "react";
import { Form as RACForm } from "react-aria-components";
import { jsx as jsx24 } from "react/jsx-runtime";
function Form(props) {
  return /* @__PURE__ */ jsx24(RACForm, { ...props });
}

// src/components/GridList/GridList.tsx
import "react";
import {
  Button as Button7,
  GridList as RACGridList,
  GridListItem as RACGridListItem
} from "react-aria-components";
import { Fragment as Fragment3, jsx as jsx25, jsxs as jsxs14 } from "react/jsx-runtime";
function GridList({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx25(RACGridList, { ...props, children });
}
function GridListItem({ children, ...props }) {
  let textValue = typeof children === "string" ? children : void 0;
  return /* @__PURE__ */ jsx25(RACGridListItem, { textValue, ...props, children: ({ selectionMode, selectionBehavior, allowsDragging }) => /* @__PURE__ */ jsxs14(Fragment3, { children: [
    allowsDragging && /* @__PURE__ */ jsx25(Button7, { slot: "drag", children: "\u2261" }),
    selectionMode === "multiple" && selectionBehavior === "toggle" && /* @__PURE__ */ jsx25(Checkbox, { slot: "selection" }),
    children
  ] }) });
}

// src/components/Icons/AddIcon.tsx
import "react";
import { jsx as jsx26 } from "react/jsx-runtime";
var AddIcon = (props) => {
  return /* @__PURE__ */ jsx26(Icon, { ...props, children: /* @__PURE__ */ jsx26(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx26("path", { d: "M13 3H11V11H3V13H11V21H13V13H21V11H13V3Z" })
    }
  ) });
};

// src/components/Icons/AligncenterIcon.tsx
import "react";
import { jsx as jsx27 } from "react/jsx-runtime";
var AligncenterIcon = (props) => {
  return /* @__PURE__ */ jsx27(Icon, { ...props, children: /* @__PURE__ */ jsx27(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx27("path", { d: "M21 7H3V5H21V7ZM17 13H7V11H17V13ZM5 19H19V17H5V19Z" })
    }
  ) });
};

// src/components/Icons/AlignleftIcon.tsx
import "react";
import { jsx as jsx28 } from "react/jsx-runtime";
var AlignleftIcon = (props) => {
  return /* @__PURE__ */ jsx28(Icon, { ...props, children: /* @__PURE__ */ jsx28(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx28("path", { d: "M21 7H3V5H21V7ZM13 13H3V11H13V13ZM3 19H17V17H3V19Z" })
    }
  ) });
};

// src/components/Icons/AlignrightIcon.tsx
import "react";
import { jsx as jsx29 } from "react/jsx-runtime";
var AlignrightIcon = (props) => {
  return /* @__PURE__ */ jsx29(Icon, { ...props, children: /* @__PURE__ */ jsx29(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx29("path", { d: "M21 7H3V5H21V7ZM21 13H11V11H21V13ZM7 19H21V17H7V19Z" })
    }
  ) });
};

// src/components/Icons/ArchiveIcon.tsx
import "react";
import { jsx as jsx30, jsxs as jsxs15 } from "react/jsx-runtime";
var ArchiveIcon = (props) => {
  return /* @__PURE__ */ jsx30(Icon, { ...props, children: /* @__PURE__ */ jsxs15(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx30("path", { d: "M8 13H16V11H8V13Z" }),
        /* @__PURE__ */ jsx30(
          "path",
          {
            fillRule: "evenodd",
            d: "M3 3H21V9H20V21H4V9H3V3ZM6 9H18V19H6V9ZM19 5V7H5V5H19Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/ArrowdownIcon.tsx
import "react";
import { jsx as jsx31 } from "react/jsx-runtime";
var ArrowdownIcon = (props) => {
  return /* @__PURE__ */ jsx31(Icon, { ...props, children: /* @__PURE__ */ jsx31(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx31("path", { d: "M6.70718 13.2929L5.29297 14.7071L12.0001 21.4142L18.7072 14.7071L17.293 13.2929L13.0001 17.5858L13.0001 3L11.0001 3L11.0001 17.5858L6.70718 13.2929Z" })
    }
  ) });
};

// src/components/Icons/ArrowleftIcon.tsx
import "react";
import { jsx as jsx32 } from "react/jsx-runtime";
var ArrowleftIcon = (props) => {
  return /* @__PURE__ */ jsx32(Icon, { ...props, children: /* @__PURE__ */ jsx32(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx32("path", { d: "M10.7073 6.70718L9.29305 5.29297L2.58594 12.0001L9.29304 18.7072L10.7073 17.293L6.41437 13.0001L21.0002 13.0001V11.0001L6.41436 11.0001L10.7073 6.70718Z" })
    }
  ) });
};

// src/components/Icons/ArrowrightIcon.tsx
import "react";
import { jsx as jsx33 } from "react/jsx-runtime";
var ArrowrightIcon = (props) => {
  return /* @__PURE__ */ jsx33(Icon, { ...props, children: /* @__PURE__ */ jsx33(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx33("path", { d: "M13.2929 17.293L14.7071 18.7072L21.4142 12.0001L14.7071 5.29297L13.2929 6.70718L17.5858 11.0001H3V13.0001H17.5858L13.2929 17.293Z" })
    }
  ) });
};

// src/components/Icons/ArrowtoprightIcon.tsx
import "react";
import { jsx as jsx34 } from "react/jsx-runtime";
var ArrowtoprightIcon = (props) => {
  return /* @__PURE__ */ jsx34(Icon, { ...props, children: /* @__PURE__ */ jsx34(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx34("path", { d: "M15.5859 7H9.5V5H19V14.5H17V8.4143L6.70718 18.7071L5.29297 17.2929L15.5859 7Z" })
    }
  ) });
};

// src/components/Icons/ArrowupIcon.tsx
import "react";
import { jsx as jsx35 } from "react/jsx-runtime";
var ArrowupIcon = (props) => {
  return /* @__PURE__ */ jsx35(Icon, { ...props, children: /* @__PURE__ */ jsx35(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx35("path", { d: "M17.293 10.7073L18.7072 9.29305L12.0001 2.58594L5.29297 9.29304L6.70718 10.7073L11.0001 6.41437L11.0001 21.0002H13.0001L13.0001 6.41436L17.293 10.7073Z" })
    }
  ) });
};

// src/components/Icons/AttachmentIcon.tsx
import "react";
import { jsx as jsx36 } from "react/jsx-runtime";
var AttachmentIcon = (props) => {
  return /* @__PURE__ */ jsx36(Icon, { ...props, children: /* @__PURE__ */ jsx36(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx36("path", { d: "M10 4C8.34315 4 7 5.34315 7 7V15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15V4H19V15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V7C5 4.23858 7.23858 2 10 2C12.7614 2 15 4.23858 15 7V15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15L9 7L11 7L11 15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V7C13 5.34315 11.6569 4 10 4Z" })
    }
  ) });
};

// src/components/Icons/AutomatedcontentIcon.tsx
import "react";
import { jsx as jsx37 } from "react/jsx-runtime";
var AutomatedcontentIcon = (props) => {
  return /* @__PURE__ */ jsx37(Icon, { ...props, children: /* @__PURE__ */ jsx37(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx37("path", { d: "M20 8C18.8954 8 18 7.10457 18 6 18 4.89543 18.8954 4 20 4 21.1046 4 22 4.89543 22 6 22 7.10457 21.1046 8 20 8ZM18 12C18 13.1046 18.8954 14 20 14 21.1046 14 22 13.1046 22 12 22 10.8954 21.1046 10 20 10 18.8954 10 18 10.8954 18 12ZM18 18C18 19.1046 18.8954 20 20 20 21.1046 20 22 19.1046 22 18 22 16.8954 21.1046 16 20 16 18.8954 16 18 16.8954 18 18ZM16 5 10 5V19H16V17H12V13L16 13V11L12 11V7H16V5ZM5.5 8.5 2 12 5.5 15.5 9 12 5.5 8.5Z" })
    }
  ) });
};

// src/components/Icons/BackgroundIcon.tsx
import "react";
import { jsx as jsx38 } from "react/jsx-runtime";
var BackgroundIcon = (props) => {
  return /* @__PURE__ */ jsx38(Icon, { ...props, children: /* @__PURE__ */ jsx38(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx38(
        "path",
        {
          fillRule: "evenodd",
          d: "M18 6H6V18H18V6ZM4 4V20H20V4H4Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/BinIcon.tsx
import "react";
import { jsx as jsx39, jsxs as jsxs16 } from "react/jsx-runtime";
var BinIcon = (props) => {
  return /* @__PURE__ */ jsx39(Icon, { ...props, children: /* @__PURE__ */ jsxs16(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx39("path", { d: "M9 18V8H11V18H9ZM13 8V18H15V8H13Z" }),
        /* @__PURE__ */ jsx39(
          "path",
          {
            fillRule: "evenodd",
            d: "M13.5 4C13.5 3.17157 12.8284 2.5 12 2.5C11.1716 2.5 10.5 3.17157 10.5 4H4V6H5V19C5 20.6569 6.34315 22 8 22H16C17.6569 22 19 20.6569 19 19V6H20V4H13.5ZM7 19V6H17V19C17 19.5523 16.5523 20 16 20H8C7.44772 20 7 19.5523 7 19Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/BlindIcon.tsx
import "react";
import { jsx as jsx40 } from "react/jsx-runtime";
var BlindIcon = (props) => {
  return /* @__PURE__ */ jsx40(Icon, { ...props, children: /* @__PURE__ */ jsx40(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx40(
        "path",
        {
          fillRule: "evenodd",
          d: "M5.92572 11.6379C7.28054 12.8798 9.29877 14.0001 12 14.0001C14.7012 14.0001 16.7195 12.8798 18.0743 11.6379C18.7544 11.0145 19.2581 10.3679 19.5858 9.83533C19.75 9.56862 19.8631 9.34158 19.932 9.1709C19.9771 9.05914 19.993 8.99662 19.9982 8.97587L19.9982 8.97582L19.9983 8.97576C19.9996 8.97052 20.0002 8.96798 20.0005 8.96802C20.0008 8.96806 20.0007 8.97041 20.0005 8.97496L20.0005 8.97506L20.0005 8.97518L20.0005 8.97534C20.0003 8.98071 20 8.989 20 9.00005H22C22 9.32108 21.894 9.65317 21.7868 9.91905C21.6681 10.2132 21.5 10.5409 21.2892 10.8835C20.9404 11.4502 20.456 12.0884 19.8359 12.7168L21.1426 14.274L19.6105 15.5596L18.3111 14.011C17.5099 14.5769 16.5733 15.0803 15.5025 15.439L15.9537 17.3931L14.0049 17.843L13.5551 15.8945C13.0587 15.963 12.5403 16.0001 12 16.0001C11.4577 16.0001 10.9375 15.9628 10.4395 15.8938L9.98878 17.846L8.04004 17.3961L8.49226 15.4373C7.41782 15.0767 6.47855 14.5704 5.67574 14.0017L4.36837 15.5597L2.83629 14.2741L4.15272 12.7053C3.53814 12.0806 3.05746 11.4468 2.71084 10.8835C2.49997 10.5409 2.33188 10.2132 2.21323 9.91905C2.10598 9.65317 2 9.32108 2 9.00005H4C4 8.98874 3.99969 8.98032 3.99949 8.97496V8.97495C3.99932 8.9704 3.99924 8.96806 3.99949 8.96802C3.99976 8.96798 4.00042 8.97055 4.00177 8.97587C4.00705 8.99663 4.02295 9.05915 4.06802 9.1709C4.13687 9.34158 4.25003 9.56862 4.41416 9.83533C4.74188 10.3679 5.24565 11.0145 5.92572 11.6379Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/BoldIcon.tsx
import "react";
import { jsx as jsx41 } from "react/jsx-runtime";
var BoldIcon = (props) => {
  return /* @__PURE__ */ jsx41(Icon, { ...props, children: /* @__PURE__ */ jsx41(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx41("path", { d: "M4.83252 20.9999H14.2185C17.6505 20.9999 20.0945 19.0239 20.0945 16.1639C20.0945 14.1879 18.8725 12.5239 16.7925 11.5879C18.3785 10.7559 19.3145 9.42994 19.3145 7.60994C19.3145 5.00994 17.0785 3.13794 13.8805 3.13794H4.83252V20.9999ZM8.65452 10.3399V6.41394H12.9445C14.3485 6.41394 15.3625 7.24594 15.3625 8.36394C15.3625 9.50794 14.3485 10.3399 12.9445 10.3399H8.65452ZM8.65452 17.7239V13.3559H13.5165C15.0505 13.3559 16.1425 14.2659 16.1425 15.5399C16.1425 16.8139 15.0505 17.7239 13.5165 17.7239H8.65452Z" })
    }
  ) });
};

// src/components/Icons/CalendarIcon.tsx
import "react";
import { jsx as jsx42 } from "react/jsx-runtime";
var CalendarIcon = (props) => {
  return /* @__PURE__ */ jsx42(Icon, { ...props, children: /* @__PURE__ */ jsx42(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx42(
        "path",
        {
          fillRule: "evenodd",
          d: "M7 2V4H3V21H21V4H17V2H15V4H9V2H7ZM19 6V8H5V6H19ZM5 10V19H19V10H5Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/CheckboxIcon.tsx
import "react";
import { jsx as jsx43 } from "react/jsx-runtime";
var CheckboxIcon = (props) => {
  return /* @__PURE__ */ jsx43(Icon, { ...props, children: /* @__PURE__ */ jsx43(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx43(
        "path",
        {
          fillRule: "evenodd",
          d: "M18.4395 5.25928L20.5608 7.3806L9.50011 18.4413L3.43945 12.3806L5.56077 10.2593L9.50011 14.1986L18.4395 5.25928Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/ChevrondownIcon.tsx
import "react";
import { jsx as jsx44 } from "react/jsx-runtime";
var ChevrondownIcon = (props) => {
  return /* @__PURE__ */ jsx44(Icon, { ...props, children: /* @__PURE__ */ jsx44(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx44(
        "path",
        {
          fill: "currentcolor",
          d: "M5.29297 9.70718L6.70718 8.29297L12.0001 13.5859L17.293 8.29297L18.7072 9.70718L12.0001 16.4143L5.29297 9.70718Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/ChevronleftIcon.tsx
import "react";
import { jsx as jsx45 } from "react/jsx-runtime";
var ChevronleftIcon = (props) => {
  return /* @__PURE__ */ jsx45(Icon, { ...props, children: /* @__PURE__ */ jsx45(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx45(
        "path",
        {
          fillRule: "evenodd",
          d: "M14.293 18.7072L15.7073 17.293L10.4144 12.0001L15.7073 6.70718L14.293 5.29297L7.58594 12.0001L14.293 18.7072Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/ChevronrightIcon.tsx
import "react";
import { jsx as jsx46 } from "react/jsx-runtime";
var ChevronrightIcon = (props) => {
  return /* @__PURE__ */ jsx46(Icon, { ...props, children: /* @__PURE__ */ jsx46(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx46(
        "path",
        {
          fillRule: "evenodd",
          d: "M9.70718 18.7072L8.29297 17.293L13.5859 12.0001L8.29297 6.70718L9.70718 5.29297L16.4143 12.0001L9.70718 18.7072Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/ChevronupIcon.tsx
import "react";
import { jsx as jsx47 } from "react/jsx-runtime";
var ChevronupIcon = (props) => {
  return /* @__PURE__ */ jsx47(Icon, { ...props, children: /* @__PURE__ */ jsx47(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx47(
        "path",
        {
          fill: "currentcolor",
          d: "M18.707 14.2928L17.2928 15.707L11.9999 10.4141L6.70703 15.707L5.29282 14.2928L11.9999 7.58571L18.707 14.2928Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/CloseIcon.tsx
import "react";
import { jsx as jsx48 } from "react/jsx-runtime";
var CloseIcon = (props) => {
  return /* @__PURE__ */ jsx48(Icon, { ...props, children: /* @__PURE__ */ jsx48(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx48("path", { d: "M12.0001 13.4143L18.293 19.7072L19.7072 18.293L13.4143 12.0001L19.7072 5.70719L18.293 4.29298L12.0001 10.5859L5.70719 4.29297L4.29298 5.70718L10.5859 12.0001L4.29297 18.293L5.70718 19.7072L12.0001 13.4143Z" })
    }
  ) });
};

// src/components/Icons/CodeIcon.tsx
import "react";
import { jsx as jsx49 } from "react/jsx-runtime";
var CodeIcon = (props) => {
  return /* @__PURE__ */ jsx49(Icon, { ...props, children: /* @__PURE__ */ jsx49(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx49("path", { d: "M6.29304 7.29297 7.70726 8.70718 4.41436 12.0001 7.70726 15.293 6.29304 16.7072 1.58594 12.0001 6.29304 7.29297ZM14.8943 8.44728 10.8943 16.4473 9.10547 15.5529 13.1055 7.55286 14.8943 8.44728ZM16.2927 15.2931 17.707 16.7073 22.4141 12.0002 17.707 7.29306 16.2927 8.70728 19.5856 12.0002 16.2927 15.2931Z" })
    }
  ) });
};

// src/components/Icons/CollectionIcon.tsx
import "react";
import { jsx as jsx50 } from "react/jsx-runtime";
var CollectionIcon = (props) => {
  return /* @__PURE__ */ jsx50(Icon, { ...props, children: /* @__PURE__ */ jsx50(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx50(
        "path",
        {
          fillRule: "evenodd",
          d: "M17 3H7V5H17V3ZM5 7H12H19V9H15.4649H12H8.53513H5V7ZM5 11H3V21H21V11H19H16H14C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11H8H5ZM12 15C10.5194 15 9.22675 14.1956 8.53513 13H5V19H19V13H15.4649C14.7733 14.1956 13.4806 15 12 15Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/ColumnafterIcon.tsx
import "react";
import { jsx as jsx51, jsxs as jsxs17 } from "react/jsx-runtime";
var ColumnafterIcon = (props) => {
  return /* @__PURE__ */ jsx51(Icon, { ...props, children: /* @__PURE__ */ jsxs17(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx51("path", { d: "M3 11L3 13H5L5 11H3Z" }),
        /* @__PURE__ */ jsx51(
          "path",
          {
            fillRule: "evenodd",
            d: "M21 21H11V3L21 3V21ZM13 19V5H19V19H13Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx51("path", { d: "M3 9 3 7H5V9H3ZM3 19 3 21H5V19H3ZM3 17 3 15H5V17H3ZM3 3 3 5H5V3L3 3ZM7 5V3L9 3V5H7ZM7 19V21H9V19H7Z" })
      ]
    }
  ) });
};

// src/components/Icons/ColumnbeforeIcon.tsx
import "react";
import { jsx as jsx52, jsxs as jsxs18 } from "react/jsx-runtime";
var ColumnbeforeIcon = (props) => {
  return /* @__PURE__ */ jsx52(Icon, { ...props, children: /* @__PURE__ */ jsxs18(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx52(
          "path",
          {
            fillRule: "evenodd",
            d: "M13 21H3L3 3L13 3V21ZM5 19L5 5H11V19H5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx52("path", { d: "M19 11V13H21V11H19ZM19 9V7H21V9H19ZM19 19V21H21V19H19ZM19 17V15H21V17H19ZM19 3V5H21V3L19 3ZM15 5V3L17 3V5H15ZM15 19V21H17V19H15Z" })
      ]
    }
  ) });
};

// src/components/Icons/ColumndeleteIcon.tsx
import "react";
import { jsx as jsx53, jsxs as jsxs19 } from "react/jsx-runtime";
var ColumndeleteIcon = (props) => {
  return /* @__PURE__ */ jsx53(Icon, { ...props, children: /* @__PURE__ */ jsxs19(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx53("path", { d: "M9 5H15V15H17V3H7V21H11V19H9V5Z" }),
        /* @__PURE__ */ jsx53("path", { d: "M16.0001 21.4142L14.2072 23.2071L12.793 21.7929L14.5859 20L12.793 18.2071L14.2072 16.7929L16.0001 18.5858L17.793 16.7929L19.2072 18.2071L17.4143 20L19.2072 21.7929L17.793 23.2071L16.0001 21.4142Z" })
      ]
    }
  ) });
};

// src/components/Icons/ColumnsIcon.tsx
import "react";
import { jsx as jsx54 } from "react/jsx-runtime";
var ColumnsIcon = (props) => {
  return /* @__PURE__ */ jsx54(Icon, { ...props, children: /* @__PURE__ */ jsx54(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx54(
        "path",
        {
          fillRule: "evenodd",
          d: "M3 21V3H21V21H3ZM13 5H19V19H13V5ZM11 5H5V19H11V5Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/CopyIcon.tsx
import "react";
import { jsx as jsx55, jsxs as jsxs20 } from "react/jsx-runtime";
var CopyIcon = (props) => {
  return /* @__PURE__ */ jsx55(Icon, { ...props, children: /* @__PURE__ */ jsxs20(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx55("path", { d: "M15 4V7H18V16H17V18H20V6L16.25 2H8V5H10V4H15Z" }),
        /* @__PURE__ */ jsx55(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 10L12.25 6H4V22H16V10ZM11 8H6V20H14V11H11V8Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/CutIcon.tsx
import "react";
import { jsx as jsx56 } from "react/jsx-runtime";
var CutIcon = (props) => {
  return /* @__PURE__ */ jsx56(Icon, { ...props, children: /* @__PURE__ */ jsx56(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx56(
        "path",
        {
          fillRule: "evenodd",
          d: "M13.4143 12.0001L14.9681 13.5539C15.5636 13.202 16.2582 13.0001 17 13.0001C19.2091 13.0001 21 14.791 21 17.0001C21 19.2092 19.2091 21.0001 17 21.0001C14.7909 21.0001 13 19.2092 13 17.0001C13 16.2583 13.2019 15.5636 13.5539 14.9681L12.0001 13.4143L10.4462 14.9682C10.7981 15.5637 11 16.2583 11 17.0001C11 19.2092 9.20914 21.0001 7 21.0001C4.79086 21.0001 3 19.2092 3 17.0001C3 14.791 4.79086 13.0001 7 13.0001C7.74183 13.0001 8.4365 13.202 9.03202 13.5539L10.5859 12.0001L3.79297 5.20718L5.20718 3.79297L12.0001 10.5859L18.793 3.793L20.2072 5.20721L13.4143 12.0001ZM5 17.0001C5 15.8955 5.89543 15.0001 7 15.0001C8.10457 15.0001 9 15.8955 9 17.0001C9 18.1047 8.10457 19.0001 7 19.0001C5.89543 19.0001 5 18.1047 5 17.0001ZM15 17.0001C15 15.8955 15.8954 15.0001 17 15.0001C18.1046 15.0001 19 15.8955 19 17.0001C19 18.1047 18.1046 19.0001 17 19.0001C15.8954 19.0001 15 18.1047 15 17.0001Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/DashIcon.tsx
import "react";
import { jsx as jsx57 } from "react/jsx-runtime";
var DashIcon = (props) => {
  return /* @__PURE__ */ jsx57(Icon, { ...props, children: /* @__PURE__ */ jsx57(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx57("path", { d: "M6 10.5H18V13.5H6z" })
    }
  ) });
};

// src/components/Icons/DiscussionIcon.tsx
import "react";
import { jsx as jsx58 } from "react/jsx-runtime";
var DiscussionIcon = (props) => {
  return /* @__PURE__ */ jsx58(Icon, { ...props, children: /* @__PURE__ */ jsx58(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx58(
        "path",
        {
          fillRule: "evenodd",
          d: "M2 8C2 5.79086 3.79086 4 6 4H14C16.2091 4 18 5.79086 18 8V9C20.2091 9 22 10.7909 22 13V15C22 16.4806 21.1956 17.7733 20 18.4649V21.5L17.5 19H14C11.7909 19 10 17.2091 10 15H6.5L4 17.5V14.4649C2.8044 13.7733 2 12.4806 2 11V8ZM6 6H14C15.1046 6 16 6.89543 16 8V11C16 12.1046 15.1046 13 14 13H6C4.89543 13 4 12.1046 4 11V8C4 6.89543 4.89543 6 6 6ZM12 15C12 16.1046 12.8954 17 14 17H18C19.1046 17 20 16.1046 20 15V13C20 11.8954 19.1046 11 18 11C18 13.2091 16.2091 15 14 15H12Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/DraggableIcon.tsx
import "react";
import { jsx as jsx59 } from "react/jsx-runtime";
var DraggableIcon = (props) => {
  return /* @__PURE__ */ jsx59(Icon, { ...props, children: /* @__PURE__ */ jsx59(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx59(
        "path",
        {
          fillRule: "evenodd",
          d: "M9 7C10.1046 7 11 6.10457 11 5C11 3.89543 10.1046 3 9 3C7.89543 3 7 3.89543 7 5C7 6.10457 7.89543 7 9 7ZM9 14C10.1046 14 11 13.1046 11 12C11 10.8954 10.1046 10 9 10C7.89543 10 7 10.8954 7 12C7 13.1046 7.89543 14 9 14ZM11 19C11 20.1046 10.1046 21 9 21C7.89543 21 7 20.1046 7 19C7 17.8954 7.89543 17 9 17C10.1046 17 11 17.8954 11 19ZM15 7C16.1046 7 17 6.10457 17 5C17 3.89543 16.1046 3 15 3C13.8954 3 13 3.89543 13 5C13 6.10457 13.8954 7 15 7ZM17 12C17 13.1046 16.1046 14 15 14C13.8954 14 13 13.1046 13 12C13 10.8954 13.8954 10 15 10C16.1046 10 17 10.8954 17 12ZM15 21C16.1046 21 17 20.1046 17 19C17 17.8954 16.1046 17 15 17C13.8954 17 13 17.8954 13 19C13 20.1046 13.8954 21 15 21Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/EditIcon.tsx
import "react";
import { jsx as jsx60, jsxs as jsxs21 } from "react/jsx-runtime";
var EditIcon = (props) => {
  return /* @__PURE__ */ jsx60(Icon, { ...props, children: /* @__PURE__ */ jsxs21(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx60("path", { d: "M18 12.8286V17.9999H6V5.99994H11.1718L13.1718 3.99994H4V19.9999H20V10.8286L18 12.8286Z" }),
        /* @__PURE__ */ jsx60(
          "path",
          {
            fillRule: "evenodd",
            d: "M13 14.9999L8 15.9999L9 10.9999L17.5858 2.41416C18.3668 1.63311 19.6332 1.63311 20.4142 2.41415L21.5858 3.58573C22.3668 4.36678 22.3668 5.63311 21.5858 6.41415L13 14.9999ZM17.5857 7.58582L12.014 13.1575L10.5495 13.4504L10.8424 11.986L16.4141 6.41424L17.5857 7.58582ZM18.9999 6.1716L20.1716 4.99994L19 3.82837L17.8283 5.00003L18.9999 6.1716Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/EyeIcon.tsx
import "react";
import { jsx as jsx61, jsxs as jsxs22 } from "react/jsx-runtime";
var EyeIcon = (props) => {
  return /* @__PURE__ */ jsx61(Icon, { ...props, children: /* @__PURE__ */ jsxs22(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx61("path", { d: "M12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5Z" }),
        /* @__PURE__ */ jsx61(
          "path",
          {
            fillRule: "evenodd",
            d: "M12 5C8.70123 5 6.21946 6.37976 4.57428 7.88785C3.75435 8.63944 3.13312 9.43033 2.71084 10.1165C2.49997 10.4592 2.33188 10.7868 2.21323 11.081C2.10598 11.3469 2 11.679 2 12C2 12.321 2.10598 12.6531 2.21323 12.919C2.33188 13.2132 2.49997 13.5408 2.71084 13.8835C3.13312 14.5697 3.75435 15.3606 4.57428 16.1122C6.21946 17.6202 8.70123 19 12 19C15.2988 19 17.7805 17.6202 19.4257 16.1122C20.2456 15.3606 20.8669 14.5697 21.2892 13.8835C21.5 13.5408 21.6681 13.2132 21.7868 12.919C21.894 12.6531 22 12.321 22 12C22 11.679 21.894 11.3469 21.7868 11.081C21.6681 10.7868 21.5 10.4592 21.2892 10.1165C20.8669 9.43033 20.2456 8.63944 19.4257 7.88785C17.7805 6.37976 15.2988 5 12 5ZM4.06802 12.1708C4.03445 12.0876 4.01707 12.0317 4.0082 12C4.01707 11.9683 4.03445 11.9124 4.06802 11.8292C4.13687 11.6585 4.25003 11.4314 4.41416 11.1647C4.74188 10.6322 5.24565 9.98556 5.92572 9.36215C7.28054 8.12024 9.29877 7 12 7C14.7012 7 16.7195 8.12024 18.0743 9.36215C18.7544 9.98556 19.2581 10.6322 19.5858 11.1647C19.75 11.4314 19.8631 11.6585 19.932 11.8292C19.9655 11.9124 19.9829 11.9683 19.9918 12C19.9829 12.0317 19.9655 12.0876 19.932 12.1708C19.8631 12.3415 19.75 12.5686 19.5858 12.8353C19.2581 13.3678 18.7544 14.0144 18.0743 14.6378C16.7195 15.8798 14.7012 17 12 17C9.29877 17 7.28054 15.8798 5.92572 14.6378C5.24565 14.0144 4.74188 13.3678 4.41416 12.8353C4.25003 12.5686 4.13687 12.3415 4.06802 12.1708Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/FilterIcon.tsx
import "react";
import { jsx as jsx62, jsxs as jsxs23 } from "react/jsx-runtime";
var FilterIcon = (props) => {
  return /* @__PURE__ */ jsx62(Icon, { ...props, children: /* @__PURE__ */ jsxs23(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx62("path", { d: "M7 8V10H17V8H7ZM9 14V12H15V14H9ZM11 16V18H13V16H11Z" }),
        /* @__PURE__ */ jsx62(
          "path",
          {
            fillRule: "evenodd",
            d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/FolderIcon.tsx
import "react";
import { jsx as jsx63 } from "react/jsx-runtime";
var FolderIcon = (props) => {
  return /* @__PURE__ */ jsx63(Icon, { ...props, children: /* @__PURE__ */ jsx63(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx63(
        "path",
        {
          fillRule: "evenodd",
          d: "M9.41421 4H2V20H22V6H11.4142L9.41421 4ZM4 18V8H20V18H4Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/FooterIcon.tsx
import "react";
import { jsx as jsx64, jsxs as jsxs24 } from "react/jsx-runtime";
var FooterIcon = (props) => {
  return /* @__PURE__ */ jsx64(Icon, { ...props, children: /* @__PURE__ */ jsxs24(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx64("path", { d: "M16 16H8V18H16V16Z" }),
        /* @__PURE__ */ jsx64(
          "path",
          {
            fillRule: "evenodd",
            d: "M4 22V2H20V22H4ZM6 4H18V20H6V4Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/ForegroundIcon.tsx
import "react";
import { jsx as jsx65 } from "react/jsx-runtime";
var ForegroundIcon = (props) => {
  return /* @__PURE__ */ jsx65(Icon, { ...props, children: /* @__PURE__ */ jsx65(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx65(
        "path",
        {
          stroke: "#000",
          strokeWidth: "2",
          d: "M3.74844 19L12.0002 4.97231L20.2516 19H3.74844Z"
        }
      )
    }
  ) });
};

// src/components/Icons/FullscreenIcon.tsx
import "react";
import { jsx as jsx66 } from "react/jsx-runtime";
var FullscreenIcon = (props) => {
  return /* @__PURE__ */ jsx66(Icon, { ...props, children: /* @__PURE__ */ jsx66(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx66("path", { d: "M21 3V9H19V5L15 5V3L21 3ZM3 3H9V5H5V9H3V3ZM3 21V15H5V19H9V21H3ZM15 21H21V15H19V19H15V21ZM12 10C10.8954 10 10 10.8954 10 12 10 13.1046 10.8954 14 12 14 13.1046 14 14 13.1046 14 12 14 10.8954 13.1046 10 12 10Z" })
    }
  ) });
};

// src/components/Icons/HighlightIcon.tsx
import "react";
import { jsx as jsx67, jsxs as jsxs25 } from "react/jsx-runtime";
var HighlightIcon = (props) => {
  return /* @__PURE__ */ jsx67(Icon, { ...props, children: /* @__PURE__ */ jsxs25(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx67("path", { d: "M9 7H15V9H13V13H11V9H9V7Z" }),
        /* @__PURE__ */ jsx67(
          "path",
          {
            fillRule: "evenodd",
            d: "M3 17V3H21V17H3ZM5 5H19V15H5V5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx67("path", { d: "M19 19H5V21H19V19Z" })
      ]
    }
  ) });
};

// src/components/Icons/HistoryIcon.tsx
import "react";
import { jsx as jsx68, jsxs as jsxs26 } from "react/jsx-runtime";
var HistoryIcon = (props) => {
  return /* @__PURE__ */ jsx68(Icon, { ...props, children: /* @__PURE__ */ jsxs26(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx68("path", { d: "M15.4998 5.93786C12.3243 4.1045 8.30946 5.04192 6.25478 8H8V10H3V5H5V6.34086C7.73535 2.94898 12.6079 1.95882 16.4998 4.20581C20.8044 6.69109 22.2793 12.1954 19.794 16.5C17.3087 20.8047 11.8044 22.2795 7.49979 19.7943C5.40842 18.5868 3.9841 16.6647 3.35878 14.5166L5.27907 13.9576C5.76607 15.6305 6.87253 17.1227 8.49979 18.0622C11.8478 19.9952 16.129 18.8481 18.062 15.5C19.995 12.152 18.8478 7.87086 15.4998 5.93786Z" }),
        /* @__PURE__ */ jsx68("path", { d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" })
      ]
    }
  ) });
};

// src/components/Icons/HomeIcon.tsx
import "react";
import { jsx as jsx69 } from "react/jsx-runtime";
var HomeIcon2 = (props) => {
  return /* @__PURE__ */ jsx69(Icon, { ...props, children: /* @__PURE__ */ jsx69(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx69(
        "path",
        {
          fillRule: "evenodd",
          d: "M21.5855 9.68946L12 2.7666L2.41455 9.68946L3.58553 11.3108L12 5.23367L20.4146 11.3108L21.5855 9.68946ZM7 12.0001H5V21.0001H11V16.0001H13V21.0001H19V12.0001H17V19.0001H15V14.0001H9V19.0001H7V12.0001Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/ImagefitIcon.tsx
import "react";
import { jsx as jsx70, jsxs as jsxs27 } from "react/jsx-runtime";
var ImagefitIcon = (props) => {
  return /* @__PURE__ */ jsx70(Icon, { ...props, children: /* @__PURE__ */ jsxs27(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx70("path", { d: "M20 3H4V5H20V3Z" }),
        /* @__PURE__ */ jsx70(
          "path",
          {
            fillRule: "evenodd",
            d: "M4 7V17H20V7H4ZM18 9H6V15H18V9Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx70("path", { d: "M4 19H20V21H4V19Z" })
      ]
    }
  ) });
};

// src/components/Icons/ImagefullIcon.tsx
import "react";
import { jsx as jsx71, jsxs as jsxs28 } from "react/jsx-runtime";
var ImagefullIcon = (props) => {
  return /* @__PURE__ */ jsx71(Icon, { ...props, children: /* @__PURE__ */ jsxs28(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx71("path", { d: "M9.70726 7.70712L8.29304 6.29291L4.58594 10L8.29304 13.7071L9.70726 12.2929L8.41435 11H15.5856L14.2927 12.2929L15.707 13.7071L19.4141 9.99999L15.707 6.29288L14.2927 7.70709L15.5857 9H8.41438L9.70726 7.70712Z" }),
        /* @__PURE__ */ jsx71(
          "path",
          {
            fillRule: "evenodd",
            d: "M2 3V17H22V3H2ZM20 5H4V15H20V5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx71("path", { d: "M4 19H20V21H4V19Z" })
      ]
    }
  ) });
};

// src/components/Icons/ImageIcon.tsx
import "react";
import { jsx as jsx72, jsxs as jsxs29 } from "react/jsx-runtime";
var ImageIcon = (props) => {
  return /* @__PURE__ */ jsx72(Icon, { ...props, children: /* @__PURE__ */ jsxs29(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx72("path", { d: "M18 10C18 11.1046 17.1046 12 16 12C14.8954 12 14 11.1046 14 10C14 8.89543 14.8954 8 16 8C17.1046 8 18 8.89543 18 10Z" }),
        /* @__PURE__ */ jsx72(
          "path",
          {
            fillRule: "evenodd",
            d: "M2 20V4H22V20H2ZM4 6H20V17.5857L16.0001 13.5858L14.0001 15.5858L8.00008 9.58582L4 13.5859V6ZM4 16.4143V18H13.5858L8.00008 12.4142L4 16.4143ZM14.4143 18H17.5858L16.0001 16.4142L14.4143 18Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/ImageleftIcon.tsx
import "react";
import { jsx as jsx73, jsxs as jsxs30 } from "react/jsx-runtime";
var ImageleftIcon = (props) => {
  return /* @__PURE__ */ jsx73(Icon, { ...props, children: /* @__PURE__ */ jsxs30(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx73(
          "path",
          {
            fillRule: "evenodd",
            d: "M2 5V15H14V5H2ZM12 7H4V13H12V7Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx73("path", { d: "M22 17V19H2V17H22ZM22 5H16V7H22V5ZM16 9H22V11H16V9ZM22 13H16V15H22V13Z" })
      ]
    }
  ) });
};

// src/components/Icons/ImagerightIcon.tsx
import "react";
import { jsx as jsx74, jsxs as jsxs31 } from "react/jsx-runtime";
var ImagerightIcon = (props) => {
  return /* @__PURE__ */ jsx74(Icon, { ...props, children: /* @__PURE__ */ jsxs31(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx74(
          "path",
          {
            fillRule: "evenodd",
            d: "M10 5V15H22V5H10ZM20 7H12V13H20V7Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx74("path", { d: "M22 17V19H2V17H22ZM8 5H2V7H8V5ZM2 9H8V11H2V9ZM8 13H2V15H8V13Z" })
      ]
    }
  ) });
};

// src/components/Icons/InfoIcon.tsx
import "react";
import { jsx as jsx75, jsxs as jsxs32 } from "react/jsx-runtime";
var InfoIcon = (props) => {
  return /* @__PURE__ */ jsx75(Icon, { ...props, children: /* @__PURE__ */ jsxs32(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx75("path", { d: "M13 16H14V18H10V16H11V12H10V10H13V16ZM12 5.5C11.1716 5.5 10.5 6.17157 10.5 7 10.5 7.82843 11.1716 8.5 12 8.5 12.8284 8.5 13.5 7.82843 13.5 7 13.5 6.17157 12.8284 5.5 12 5.5Z" }),
        /* @__PURE__ */ jsx75(
          "path",
          {
            fillRule: "evenodd",
            d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/ItalicIcon.tsx
import "react";
import { jsx as jsx76 } from "react/jsx-runtime";
var ItalicIcon = (props) => {
  return /* @__PURE__ */ jsx76(Icon, { ...props, children: /* @__PURE__ */ jsx76(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx76(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 3H17V5H14.3584L11.4443 19H14V21L11.028 21H9L7 21V19H9.4163L12.3304 5H10V3Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/LanguageIcon.tsx
import "react";
import { jsx as jsx77 } from "react/jsx-runtime";
var LanguageIcon = (props) => {
  return /* @__PURE__ */ jsx77(Icon, { ...props, children: /* @__PURE__ */ jsx77(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx77(
        "path",
        {
          fillRule: "evenodd",
          d: "M13 3H11V6H4V8H6.14603C6.72201 10.8754 8.4029 13.2122 10.3922 15.0269C8.05005 16.8465 5.43103 18.0192 3.70898 18.5433L4.29131 20.4566C6.30162 19.8448 9.32436 18.4761 11.9749 16.3239C14.5162 18.201 17.3216 19.4054 19.2194 19.9599L19.7803 18.0401C18.1527 17.5646 15.7289 16.535 13.4937 14.954C15.3226 13.1144 16.8284 10.8003 17.3604 8H20V6H13V3ZM8.19558 8H15.3165C14.8002 10.2269 13.5262 12.1292 11.9131 13.7052C10.155 12.1472 8.7535 10.2439 8.19558 8Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/LeadingIcon.tsx
import "react";
import { jsx as jsx78, jsxs as jsxs33 } from "react/jsx-runtime";
var LeadingIcon = (props) => {
  return /* @__PURE__ */ jsx78(Icon, { ...props, children: /* @__PURE__ */ jsxs33(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx78("path", { d: "M12.9258 9.2258L12 7L11.0742 9.2258L8.6713 9.41844L10.5021 10.9867L9.94275 13.3316L12 12.075L14.0572 13.3316L13.4979 10.9867L15.3287 9.41844L12.9258 9.2258Z" }),
        /* @__PURE__ */ jsx78(
          "path",
          {
            fillRule: "evenodd",
            d: "M12 21L23 10L18 3L6 3L1 10L12 21ZM16.9708 5L20.3878 9.7838L12 18.1716L3.61223 9.7838L7.02924 5L16.9708 5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/LeadingimageIcon.tsx
import "react";
import { jsx as jsx79 } from "react/jsx-runtime";
var LeadingimageIcon = (props) => {
  return /* @__PURE__ */ jsx79(Icon, { ...props, children: /* @__PURE__ */ jsx79(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx79(
        "path",
        {
          fillRule: "evenodd",
          d: "M12 21L1 10L6 3L18 3L23 10L12 21ZM20.3878 9.7838L16.9708 5L7.02924 5L3.61223 9.7838L5.64752 11.8191L8.95092 8.45923L12.4176 12.0173L14.9116 9.49744C14.1243 9.45168 13.5 8.79875 13.5 8C13.5 7.17157 14.1716 6.5 15 6.5C15.8284 6.5 16.5 7.17157 16.5 8C16.5 8.82843 15.8284 9.5 15 9.5C14.9927 9.5 14.9853 9.49995 14.978 9.49984L17.8007 12.3708L20.3878 9.7838ZM12 18.1716L7.06179 13.2334L8.94444 11.3185L12.4063 14.8717L14.939 12.3129L16.3865 13.7851L12 18.1716Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/LinkIcon.tsx
import "react";
import { jsx as jsx80, jsxs as jsxs34 } from "react/jsx-runtime";
var LinkIcon = (props) => {
  return /* @__PURE__ */ jsx80(Icon, { ...props, children: /* @__PURE__ */ jsxs34(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx80("path", { d: "M15 7V10H17V7C17 4.23858 14.7614 2 12 2 9.23858 2 7 4.23858 7 7V10H9V7C9 5.34315 10.3431 4 12 4 13.6569 4 15 5.34315 15 7ZM15 17V14H17V17C17 19.7614 14.7614 22 12 22 9.23858 22 7 19.7614 7 17V14H9V17C9 18.6569 10.3431 20 12 20 13.6569 20 15 18.6569 15 17Z" }),
        /* @__PURE__ */ jsx80("path", { d: "M13 8H11V16H13V8Z" })
      ]
    }
  ) });
};

// src/components/Icons/ListIcon.tsx
import "react";
import { jsx as jsx81 } from "react/jsx-runtime";
var ListIcon = (props) => {
  return /* @__PURE__ */ jsx81(Icon, { ...props, children: /* @__PURE__ */ jsx81(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx81("path", { d: "M2 6C2 4.89542 2.89545 4 4 4 5.10455 4 6 4.89542 6 6 6 7.10455 5.10455 8 4 8 2.89545 8 2 7.10455 2 6ZM22 5H8V7H22V5ZM22 11H8V13H22V11ZM8 17H22V19H8V17ZM4 10C2.89545 10 2 10.8954 2 12 2 13.1046 2.89545 14 4 14 5.10455 14 6 13.1046 6 12 6 10.8954 5.10455 10 4 10ZM4 16C2.89545 16 2 16.8954 2 18 2 19.1046 2.89545 20 4 20 5.10455 20 6 19.1046 6 18 6 16.8954 5.10455 16 4 16Z" })
    }
  ) });
};

// src/components/Icons/ListnumbersIcon.tsx
import "react";
import { jsx as jsx82 } from "react/jsx-runtime";
var ListnumbersIcon = (props) => {
  return /* @__PURE__ */ jsx82(Icon, { ...props, children: /* @__PURE__ */ jsx82(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx82("path", { d: "M4.97748 7.99993H3.81348V5.18593L3.12348 5.60593 2.66748 4.80193 4.04748 3.87793H4.97748V7.99993ZM22 4.99994H8V6.99994H22V4.99994ZM22 10.9999H8V12.9999H22V10.9999ZM8 16.9999H22V18.9999H8V16.9999ZM2.33421 14H5.63421V12.962H4.11621L4.65021 12.62C5.38221 12.152 5.59821 11.732 5.59821 11.192 5.59821 10.394 4.93821 9.80597 3.96021 9.80597 3.27621 9.80597 2.71821 10.082 2.26221 10.622L2.98221 11.348C3.30021 11.03 3.57621 10.862 3.93021 10.862 4.20021 10.862 4.39821 11.012 4.39821 11.24 4.39821 11.456 4.29621 11.642 3.86421 11.954L2.33421 13.058V14ZM5.66987 18.824C5.66987 19.556 5.00987 20.078 3.97787 20.078 3.19187 20.078 2.59787 19.802 2.21387 19.394L2.86787 18.62C3.17387 18.908 3.55787 19.04 3.91187 19.04 4.28387 19.04 4.46987 18.902 4.46987 18.716 4.46987 18.518 4.33187 18.41 3.83987 18.416L3.34187 18.422V17.45H3.83387C4.21787 17.45 4.39187 17.348 4.39187 17.162 4.39187 16.958 4.18187 16.844 3.84587 16.844 3.50387 16.844 3.20987 17.006 2.94587 17.252L2.30387 16.538C2.66387 16.124 3.17987 15.806 3.97187 15.806 4.99187 15.806 5.57987 16.292 5.57987 16.94 5.57987 17.384 5.29187 17.738 4.82387 17.876 5.29187 17.984 5.66987 18.314 5.66987 18.824Z" })
    }
  ) });
};

// src/components/Icons/MailIcon.tsx
import "react";
import { jsx as jsx83 } from "react/jsx-runtime";
var MailIcon = (props) => {
  return /* @__PURE__ */ jsx83(Icon, { ...props, children: /* @__PURE__ */ jsx83(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx83(
        "path",
        {
          fillRule: "evenodd",
          d: "M2 20V4H22V20H2ZM18.5859 6H5.41427L12.0001 12.5858L18.5859 6ZM4 7.41415V18H20V7.4143L12.0001 15.4142L4 7.41415Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/MandatoryIcon.tsx
import "react";
import { jsx as jsx84 } from "react/jsx-runtime";
var MandatoryIcon = (props) => {
  return /* @__PURE__ */ jsx84(Icon, { ...props, children: /* @__PURE__ */ jsx84(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx84(
        "path",
        {
          fillRule: "evenodd",
          d: "M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/MapIcon.tsx
import "react";
import { jsx as jsx85, jsxs as jsxs35 } from "react/jsx-runtime";
var MapIcon = (props) => {
  return /* @__PURE__ */ jsx85(Icon, { ...props, children: /* @__PURE__ */ jsxs35(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx85("path", { d: "M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z" }),
        /* @__PURE__ */ jsx85(
          "path",
          {
            fillRule: "evenodd",
            d: "M20 10C20 16 12 22.5 12 22.5C12 22.5 4 16 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10ZM18 10C18 12.2326 16.4373 14.8758 14.4702 17.2117C13.5849 18.263 12.6945 19.163 12 19.8205C11.3055 19.163 10.4151 18.263 9.52982 17.2117C7.5627 14.8758 6 12.2326 6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/MenuIcon.tsx
import "react";
import { jsx as jsx86 } from "react/jsx-runtime";
var MenuIcon = (props) => {
  return /* @__PURE__ */ jsx86(Icon, { ...props, children: /* @__PURE__ */ jsx86(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx86("path", { d: "M21 7H3V5H21V7ZM21 13H3V11H21V13ZM3 19H21V17H3V19Z" })
    }
  ) });
};

// src/components/Icons/MergedIcon.tsx
import "react";
import { jsx as jsx87 } from "react/jsx-runtime";
var MergedIcon = (props) => {
  return /* @__PURE__ */ jsx87(Icon, { ...props, children: /* @__PURE__ */ jsx87(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx87(
        "path",
        {
          fillRule: "evenodd",
          d: "M3 21V3H21V21H3ZM5 5H19V19H5V5Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/MoreoptionsIcon.tsx
import "react";
import { jsx as jsx88 } from "react/jsx-runtime";
var MoreoptionsIcon = (props) => {
  return /* @__PURE__ */ jsx88(Icon, { ...props, children: /* @__PURE__ */ jsx88(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx88("path", { d: "M7 12.0001C7 13.1046 6.10457 14.0001 5 14.0001 3.89543 14.0001 3 13.1046 3 12.0001 3 10.8955 3.89543 10.0001 5 10.0001 6.10457 10.0001 7 10.8955 7 12.0001ZM14 11.9724C14 13.077 13.1046 13.9724 12 13.9724 10.8954 13.9724 10 13.077 10 11.9724 10 10.8678 10.8954 9.97241 12 9.97241 13.1046 9.97241 14 10.8678 14 11.9724ZM19.0002 14.0001C20.1048 14.0001 21.0002 13.1046 21.0002 12.0001 21.0002 10.8955 20.1048 10.0001 19.0002 10.0001 17.8956 10.0001 17.0002 10.8955 17.0002 12.0001 17.0002 13.1046 17.8956 14.0001 19.0002 14.0001Z" })
    }
  ) });
};

// src/components/Icons/NavigationIcon.tsx
import "react";
import { jsx as jsx89 } from "react/jsx-runtime";
var NavigationIcon = (props) => {
  return /* @__PURE__ */ jsx89(Icon, { ...props, children: /* @__PURE__ */ jsx89(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx89("path", { d: "M12 2C10.8954 2 10 2.89543 10 4 10 5.10457 10.8954 6 12 6 13.1046 6 14 5.10457 14 4 14 2.89543 13.1046 2 12 2ZM4 16C2.89543 16 2 16.8954 2 18 2 19.1046 2.89543 20 4 20 5.10457 20 6 19.1046 6 18 6 16.8954 5.10457 16 4 16ZM10 18C10 16.8954 10.8954 16 12 16 13.1046 16 14 16.8954 14 18 14 19.1046 13.1046 20 12 20 10.8954 20 10 19.1046 10 18ZM20 16C18.8954 16 18 16.8954 18 18 18 19.1046 18.8954 20 20 20 21.1046 20 22 19.1046 22 18 22 16.8954 21.1046 16 20 16ZM13 10H21V14H19V12H13V14H11V12H5V14H3V10H11V8H13V10Z" })
    }
  ) });
};

// src/components/Icons/NewsIcon.tsx
import "react";
import { jsx as jsx90, jsxs as jsxs36 } from "react/jsx-runtime";
var NewsIcon = (props) => {
  return /* @__PURE__ */ jsx90(Icon, { ...props, children: /* @__PURE__ */ jsxs36(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx90("path", { d: "M15 7H7V9H15V7Z" }),
        /* @__PURE__ */ jsx90(
          "path",
          {
            fillRule: "evenodd",
            d: "M15 11V17H7V11H15ZM13 15V13H9V15H13Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx90(
          "path",
          {
            fillRule: "evenodd",
            d: "M19 3H3V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V15H19V3ZM5 18V5H17V19H6C5.44772 19 5 18.5523 5 18Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/OutIcon.tsx
import "react";
import { jsx as jsx91, jsxs as jsxs37 } from "react/jsx-runtime";
var OutIcon = (props) => {
  return /* @__PURE__ */ jsx91(Icon, { ...props, children: /* @__PURE__ */ jsxs37(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx91("path", { d: "M11 18C12.4021 18 13.6918 17.5191 14.7133 16.7133L16.1348 18.1348C14.7454 19.2991 12.9545 20 11 20C6.58172 20 3 16.4183 3 12C3 7.58172 6.58172 4 11 4C12.9545 4 14.7454 4.70094 16.1348 5.86515L14.7133 7.28675C13.6918 6.4809 12.4021 6 11 6C7.68629 6 5 8.68629 5 12C5 15.3137 7.68629 18 11 18Z" }),
        /* @__PURE__ */ jsx91("path", { d: "M22.4141 12L17.707 16.7071L16.2927 15.2929L18.5857 13L10 13V11L18.5856 11L16.2927 8.70712L17.707 7.29291L22.4141 12Z" })
      ]
    }
  ) });
};

// src/components/Icons/PageIcon.tsx
import "react";
import { jsx as jsx92 } from "react/jsx-runtime";
var PageIcon = (props) => {
  return /* @__PURE__ */ jsx92(Icon, { ...props, children: /* @__PURE__ */ jsx92(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx92(
        "path",
        {
          fillRule: "evenodd",
          d: "M20 7L15 2H4V22H20V7ZM18 8.00003V20H6V4H14C14 4.00001 14 3.99999 14 4V8.00003H18Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/ParagraphIcon.tsx
import "react";
import { jsx as jsx93 } from "react/jsx-runtime";
var ParagraphIcon = (props) => {
  return /* @__PURE__ */ jsx93(Icon, { ...props, children: /* @__PURE__ */ jsx93(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx93(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 2C6.68629 2 4 4.68629 4 8C4 11.3137 6.68629 14 10 14H13V22H15V4H17V22H19V2H10ZM10 4H13V12H10C7.79086 12 6 10.2091 6 8C6 5.79086 7.79086 4 10 4Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/PasteIcon.tsx
import "react";
import { jsx as jsx94, jsxs as jsxs38 } from "react/jsx-runtime";
var PasteIcon = (props) => {
  return /* @__PURE__ */ jsx94(Icon, { ...props, children: /* @__PURE__ */ jsxs38(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx94("path", { d: "M15 3H13.5C13.5 2.17157 12.8284 1.5 12 1.5C11.1716 1.5 10.5 2.17157 10.5 3H9V7H15V3Z" }),
        /* @__PURE__ */ jsx94("path", { d: "M4 4H7V6H6V20H18V6H17V4H20V22H4V4Z" })
      ]
    }
  ) });
};

// src/components/Icons/PauseIcon.tsx
import "react";
import { jsx as jsx95, jsxs as jsxs39 } from "react/jsx-runtime";
var PauseIcon = (props) => {
  return /* @__PURE__ */ jsx95(Icon, { ...props, children: /* @__PURE__ */ jsxs39(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx95("path", { d: "M9 9H11V15H9V9ZM15 9H13V15H15V9Z" }),
        /* @__PURE__ */ jsx95(
          "path",
          {
            fillRule: "evenodd",
            d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/PencilIcon.tsx
import "react";
import { jsx as jsx96 } from "react/jsx-runtime";
var PencilIcon = (props) => {
  return /* @__PURE__ */ jsx96(Icon, { ...props, children: /* @__PURE__ */ jsx96(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx96(
        "path",
        {
          fillRule: "evenodd",
          d: "M19.0927 3.32161C18.3117 2.54056 17.0453 2.54056 16.2643 3.32161L4.2357 15.3502L3.5 20.5001L8.64992 19.7644L20.6785 7.73583C21.4596 6.95478 21.4596 5.68845 20.6785 4.9074L19.0927 3.32161ZM5.85702 18.1431L6.12132 16.293L14.6786 7.73571L16.2644 9.3215L7.70711 17.8788L5.85702 18.1431ZM17.6786 7.90728L19.2643 6.32161L17.6785 4.73582L16.0928 6.3215L17.6786 7.90728Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/PlayIcon.tsx
import "react";
import { jsx as jsx97, jsxs as jsxs40 } from "react/jsx-runtime";
var PlayIcon = (props) => {
  return /* @__PURE__ */ jsx97(Icon, { ...props, children: /* @__PURE__ */ jsxs40(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx97("path", { d: "M10 15.4641L16 12L10 8.53589L10 15.4641Z" }),
        /* @__PURE__ */ jsx97(
          "path",
          {
            fillRule: "evenodd",
            d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/PropertiesIcon.tsx
import "react";
import { jsx as jsx98 } from "react/jsx-runtime";
var PropertiesIcon = (props) => {
  return /* @__PURE__ */ jsx98(Icon, { ...props, children: /* @__PURE__ */ jsx98(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx98("path", { d: "M4.66674 8.74762 8.70718 4.70718 7.29297 3.29297 4.66674 5.9192 3.70718 4.95964 2.29297 6.37385 4.66674 8.74762ZM22 5.00006H10V7.00006H22V5.00006ZM22 11.0001H10V13.0001H22V11.0001ZM10 17.0001H22V19.0001H10V17.0001ZM8.70718 10.7072 4.66674 14.7476 2.29297 12.3738 3.70718 10.9596 4.66674 11.9192 7.29297 9.29297 8.70718 10.7072ZM4.66674 20.7476 8.70718 16.7072 7.29297 15.293 4.66674 17.9192 3.70718 16.9596 2.29297 18.3738 4.66674 20.7476Z" })
    }
  ) });
};

// src/components/Icons/QuotesIcon.tsx
import "react";
import { jsx as jsx99 } from "react/jsx-runtime";
var QuotesIcon = (props) => {
  return /* @__PURE__ */ jsx99(Icon, { ...props, children: /* @__PURE__ */ jsx99(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx99(
        "path",
        {
          fillRule: "evenodd",
          d: "M7 6C9.20914 6 11 7.79086 11 10 11 13.5653 8.81985 16.6682 5.55262 18.8336L4.44775 17.1664C5.87998 16.2172 7.00481 15.1169 7.77807 13.9244 7.52639 13.974 7.26623 14 7 14 4.79086 14 3 12.2091 3 10 3 7.79086 4.79086 6 7 6ZM9 10C9 11.1046 8.10457 12 7 12 5.89543 12 5 11.1046 5 10 5 8.89543 5.89543 8 7 8 8.10457 8 9 8.89543 9 10ZM17.7781 13.9244C17.5264 13.974 17.2662 14 17 14 14.7909 14 13 12.2091 13 10 13 7.79086 14.7909 6 17 6 19.2091 6 21 7.79086 21 10 21 13.5653 18.8199 16.6682 15.5526 18.8336L14.4478 17.1664C15.88 16.2172 17.0048 15.1169 17.7781 13.9244ZM19 10C19 11.1046 18.1046 12 17 12 15.8954 12 15 11.1046 15 10 15 8.89543 15.8954 8 17 8 18.1046 8 19 8.89543 19 10Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/RadiobuttonIcon.tsx
import "react";
import { jsx as jsx100 } from "react/jsx-runtime";
var RadiobuttonIcon = (props) => {
  return /* @__PURE__ */ jsx100(Icon, { ...props, children: /* @__PURE__ */ jsx100(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx100(
        "path",
        {
          fillRule: "evenodd",
          d: "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/RedoIcon.tsx
import "react";
import { jsx as jsx101 } from "react/jsx-runtime";
var RedoIcon = (props) => {
  return /* @__PURE__ */ jsx101(Icon, { ...props, children: /* @__PURE__ */ jsx101(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx101(
        "path",
        {
          fillRule: "evenodd",
          d: "M18.9998 6.34195C16.2646 2.94959 11.3917 1.95918 7.49955 4.2063C3.19492 6.69158 1.72004 12.1959 4.20532 16.5005C6.69065 20.805 12.1955 22.2794 16.5001 19.7942L15.5001 18.0621C12.1521 19.9951 7.87093 18.848 5.93794 15.5C4.00509 12.1519 5.15156 7.87131 8.49955 5.93835C11.6749 4.10503 15.6897 5.04236 17.7444 8.00024H14.9998V10.0002H20.9998V4.00024H18.9998V6.34195ZM18.9282 8.00024H18.9998V7.95891L18.9282 8.00024Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/RenameIcon.tsx
import "react";
import { jsx as jsx102, jsxs as jsxs41 } from "react/jsx-runtime";
var RenameIcon = (props) => {
  return /* @__PURE__ */ jsx102(Icon, { ...props, children: /* @__PURE__ */ jsxs41(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx102("path", { d: "M15 3H21V5H19V19H21V21H15V19H17V5H15V3Z" }),
        /* @__PURE__ */ jsx102(
          "path",
          {
            fillRule: "evenodd",
            d: "M13.9362 17H11.7122L10.8482 14.92H5.60021L4.73621 17H2.51221L7.12021 6.008H9.32821L13.9362 17ZM8.22421 8.648L6.28821 13.288H10.1602L8.22421 8.648Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/ReverseIcon.tsx
import "react";
import { jsx as jsx103 } from "react/jsx-runtime";
var ReverseIcon = (props) => {
  return /* @__PURE__ */ jsx103(Icon, { ...props, children: /* @__PURE__ */ jsx103(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx103("path", { d: "M10.1885 5.23831C8.52721 5.68346 7.16654 6.68944 6.25535 7.99985H8V9.99985H3V4.99985H5V6.34247C6.15482 4.91139 7.75799 3.81902 9.67087 3.30646 14.4721 2.01998 19.4071 4.86923 20.6936 9.67042L18.7617 10.1881C17.7611 6.4538 13.9228 4.23772 10.1885 5.23831ZM5.23876 13.8115C6.23935 17.5458 10.0777 19.7619 13.812 18.7613 15.4731 18.3162 16.8339 17.3102 17.7451 15.9998H16V13.9998H21V18.9998H19V17.6577C17.8452 19.0885 16.2423 20.1806 14.3296 20.6931 9.52842 21.9796 4.59339 19.1304 3.30691 14.3292L5.23876 13.8115Z" })
    }
  ) });
};

// src/components/Icons/ReviewIcon.tsx
import "react";
import { jsx as jsx104, jsxs as jsxs42 } from "react/jsx-runtime";
var ReviewIcon = (props) => {
  return /* @__PURE__ */ jsx104(Icon, { ...props, children: /* @__PURE__ */ jsxs42(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx104(
          "path",
          {
            fillRule: "evenodd",
            d: "M2 8C2 5.79086 3.79086 4 6 4H18C20.2091 4 22 5.79086 22 8V20H6C3.79086 20 2 18.2091 2 16V8ZM6 6H18C19.1046 6 20 6.89543 20 8V18H6C4.89543 18 4 17.1046 4 16V8C4 6.89543 4.89543 6 6 6Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx104("path", { d: "M12.9258 10.7258L12.0001 8.5L11.0743 10.7258L8.67139 10.9184L10.5022 12.4867L9.94284 14.8316L12.0001 13.575L14.0573 14.8316L13.498 12.4867L15.3288 10.9184L12.9258 10.7258Z" })
      ]
    }
  ) });
};

// src/components/Icons/RowafterIcon.tsx
import "react";
import { jsx as jsx105, jsxs as jsxs43 } from "react/jsx-runtime";
var RowafterIcon = (props) => {
  return /* @__PURE__ */ jsx105(Icon, { ...props, children: /* @__PURE__ */ jsxs43(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx105("path", { d: "M13 3H11V5H13V3Z" }),
        /* @__PURE__ */ jsx105(
          "path",
          {
            fillRule: "evenodd",
            d: "M3 21V11H21V21H3ZM5 13H19V19H5V13Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx105("path", { d: "M15 3H17V5H15V3ZM5 3H3V5H5V3ZM7 3H9V5H7V3ZM21 3H19V5H21V3ZM19 7H21V9H19V7ZM5 7H3V9H5V7Z" })
      ]
    }
  ) });
};

// src/components/Icons/RowbeforeIcon.tsx
import "react";
import { jsx as jsx106, jsxs as jsxs44 } from "react/jsx-runtime";
var RowbeforeIcon = (props) => {
  return /* @__PURE__ */ jsx106(Icon, { ...props, children: /* @__PURE__ */ jsxs44(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx106(
          "path",
          {
            fillRule: "evenodd",
            d: "M3 13V3H21V13H3ZM5 5H19V11H5V5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx106("path", { d: "M13 19H11V21H13V19ZM15 19H17V21H15V19ZM5 19H3V21H5V19ZM7 19H9V21H7V19ZM21 19H19V21H21V19ZM19 15H21V17H19V15ZM5 15H3V17H5V15Z" })
      ]
    }
  ) });
};

// src/components/Icons/RowdeleteIcon.tsx
import "react";
import { jsx as jsx107, jsxs as jsxs45 } from "react/jsx-runtime";
var RowdeleteIcon = (props) => {
  return /* @__PURE__ */ jsx107(Icon, { ...props, children: /* @__PURE__ */ jsxs45(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx107("path", { d: "M5 9H19V11H21V7H3V17H15V15H5V9Z" }),
        /* @__PURE__ */ jsx107("path", { d: "M20.0001 17.4142L18.2072 19.2071L16.793 17.7929L18.5859 16L16.793 14.2071L18.2072 12.7929L20.0001 14.5858L21.793 12.7929L23.2072 14.2071L21.4143 16L23.2072 17.7929L21.793 19.2071L20.0001 17.4142Z" })
      ]
    }
  ) });
};

// src/components/Icons/SearchIcon.tsx
import "react";
import { jsx as jsx108 } from "react/jsx-runtime";
var SearchIcon = (props) => {
  return /* @__PURE__ */ jsx108(Icon, { ...props, children: /* @__PURE__ */ jsx108(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx108(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C11.5723 17 13.0236 16.4816 14.1922 15.6064L19.2929 20.7071L20.7071 19.2929L15.6064 14.1922C16.4816 13.0236 17 11.5723 17 10C17 6.13401 13.866 3 10 3ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/SecurityIcon.tsx
import "react";
import { jsx as jsx109 } from "react/jsx-runtime";
var SecurityIcon = (props) => {
  return /* @__PURE__ */ jsx109(Icon, { ...props, children: /* @__PURE__ */ jsx109(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx109(
        "path",
        {
          fillRule: "evenodd",
          d: "M4 2V12.3197C4 16.1074 6.14002 19.57 9.52786 21.2639L12 22.5L14.4721 21.2639C17.86 19.57 20 16.1074 20 12.3197V2H4ZM13 4H18V12.3197C18 15.3498 16.288 18.1199 13.5777 19.4751L13 19.7639V4ZM11 4V19.7639L10.4223 19.4751C7.71202 18.1199 6 15.3498 6 12.3197V4H11Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/SettingsIcon.tsx
import "react";
import { jsx as jsx110, jsxs as jsxs46 } from "react/jsx-runtime";
var SettingsIcon = (props) => {
  return /* @__PURE__ */ jsx110(Icon, { ...props, children: /* @__PURE__ */ jsxs46(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx110("path", { d: "M12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5Z" }),
        /* @__PURE__ */ jsx110(
          "path",
          {
            fillRule: "evenodd",
            d: "M5.59047 4.61667L7.73535 5.23024C7.90906 5.12057 8.08729 5.01742 8.26969 4.9211L8.8106 2.75746C8.92189 2.3123 9.32187 2 9.78074 2H14.2192C14.6781 2 15.078 2.3123 15.1893 2.75746L15.7302 4.9211C15.9127 5.01743 16.0909 5.1206 16.2646 5.23028L18.4097 4.61667C18.8509 4.49047 19.3213 4.68071 19.5507 5.07811L21.77 8.92191C21.9994 9.3193 21.9289 9.82185 21.5991 10.1408L19.9942 11.6926C19.998 11.7946 20 11.8971 20 12C20 12.103 19.998 12.2055 19.9942 12.3075L21.5991 13.8593C21.9289 14.1782 21.9994 14.6808 21.77 15.0782L19.5507 18.922C19.3213 19.3194 18.8509 19.5096 18.4097 19.3834L16.2646 18.7698C16.0909 18.8794 15.9126 18.9826 15.7303 19.0789L15.1893 21.2426C15.078 21.6878 14.6781 22.0001 14.2192 22.0001H9.78074C9.32187 22.0001 8.92189 21.6878 8.8106 21.2426L8.26967 19.0789C8.08728 18.9826 7.90907 18.8794 7.73537 18.7698L5.59047 19.3834C5.1493 19.5096 4.67885 19.3193 4.44942 18.9219L2.23019 15.0781C2.00076 14.6807 2.07123 14.1782 2.40111 13.8592L4.00577 12.3076C4.00191 12.2056 3.99996 12.103 3.99996 12C3.99996 11.897 4.00191 11.7944 4.00577 11.6924L2.40111 10.1408C2.07123 9.82185 2.00076 9.31931 2.23019 8.92191L4.44942 5.07811C4.67885 4.68071 5.1493 4.49047 5.59047 4.61667ZM13.4384 4L14.0066 6.27263L14.7963 6.68967C14.933 6.76185 15.0667 6.8392 15.197 6.92148L15.954 7.39936L18.2091 6.75428L19.6475 9.24574L17.9619 10.8756L17.9956 11.7681C17.9985 11.8449 18 11.9222 18 12C18 12.0778 17.9985 12.1551 17.9956 12.232L17.9619 13.1245L19.6475 14.7543L18.2091 17.2458L15.9539 16.6007L15.1969 17.0786C15.0666 17.1608 14.933 17.2382 14.7964 17.3103L14.0066 17.7274L13.4384 20.0001H10.5615L9.99334 17.7274L9.20357 17.3103C9.0669 17.2382 8.93328 17.1608 8.80298 17.0786L8.04599 16.6007L5.79108 17.2457L4.35263 14.7543L6.03809 13.1246L6.00434 12.2321C6.00143 12.1552 5.99996 12.0778 5.99996 12C5.99996 11.9222 6.00143 11.8448 6.00434 11.7679L6.03808 10.8754L4.35263 9.24574L5.79108 6.75428L8.04597 7.39931L8.80297 6.92145C8.93328 6.83918 9.06691 6.76184 9.20358 6.68967L9.99336 6.27263L10.5615 4H13.4384Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/ShareIcon.tsx
import "react";
import { jsx as jsx111, jsxs as jsxs47 } from "react/jsx-runtime";
var ShareIcon = (props) => {
  return /* @__PURE__ */ jsx111(Icon, { ...props, children: /* @__PURE__ */ jsxs47(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx111("path", { d: "M17 4H19V7H22V9H19V12H17V9H14V7H17V4Z" }),
        /* @__PURE__ */ jsx111(
          "path",
          {
            fillRule: "evenodd",
            d: "M13.3819 14.8618C13.3819 14.8618 14.156 15.2587 14.5877 15.5754C15.2779 16.0817 16.0732 16.8818 16.3217 18C16.3504 18.1291 16.3718 18.2624 16.3849 18.4C16.3948 18.5041 16.4 18.6106 16.4 18.7196V20L2 20L2 18.7196C2 18.6106 2.00518 18.5041 2.01509 18.4C2.0282 18.2624 2.0496 18.1291 2.07828 18C2.32658 16.8823 3.12062 16.0826 3.80611 15.5777C4.24345 15.2556 4.68302 15.0177 5.01726 14.859C5.17463 14.7843 5.30866 14.7271 5.4081 14.687L5.58887 14.6179L5.66038 14.5963C6.26182 14.4454 6.49887 14.2588 6.57556 14.1823L6.57415 13.5893C6.09164 13.1281 5.87178 12.5905 5.77247 12.1848C5.46152 11.8317 5.2529 11.4055 5.14173 10.8622C5.07124 10.5178 5.06936 10.1927 5.15098 9.88435C5.18373 9.76058 5.22757 9.64854 5.27799 9.54693L5.25537 9.4743L5.24898 9.44731C4.93626 8.12731 5.04708 7.08466 5.38775 6.27783C5.72576 5.47727 6.26031 4.97981 6.67835 4.69287C7.67082 4.01106 8.78472 4 9.21783 4C10.2301 4 10.9362 4.55189 11.3179 4.95238C11.8459 5.11349 12.3048 5.45723 12.6421 5.91119C12.8847 6.23768 13.1342 6.67044 13.2573 7.26733C13.3791 7.85792 13.3668 8.55847 13.1649 9.41355L13.1586 9.44015L13.1252 9.54806C13.3264 9.93791 13.4457 10.464 13.2053 11.045L13.1459 11.1907L13.1452 11.1924L13.1273 11.2371C13.034 11.4706 12.8856 11.8419 12.6355 12.1619C12.5387 12.569 12.3203 13.1181 11.8286 13.5884V14.2886C11.943 14.3517 12.193 14.4582 12.6989 14.5846L12.7304 14.5924L12.7611 14.6028C12.7732 14.6069 12.7925 14.6136 12.8183 14.623C12.8599 14.6382 12.9185 14.6604 12.991 14.6897C13.0955 14.732 13.3819 14.8618 13.3819 14.8618ZM11.2272 8.91598C11.3674 8.30346 11.3486 7.91438 11.2985 7.67121C11.2493 7.43251 11.1559 7.2643 11.0368 7.10413C10.9252 6.95386 10.8091 6.88818 10.7343 6.86533L10.2322 6.71215L9.87003 6.33214C9.67345 6.12586 9.4557 6 9.21783 6C8.82584 6 8.26127 6.03191 7.81083 6.34135C7.62244 6.47066 7.3837 6.69234 7.23024 7.05578C7.08237 7.40601 6.96718 7.99518 7.18609 8.94759L7.42594 9.71769L7.09053 10.3937C7.09194 10.4086 7.09491 10.4309 7.10113 10.4613C7.15059 10.703 7.21857 10.8007 7.2734 10.863L7.59826 11.2318L7.71513 11.7093C7.75185 11.8593 7.82353 12.0168 7.95612 12.1436L8.57212 12.7324L8.57754 15.0102L7.98805 15.5982C7.6028 15.9825 7.03137 16.3048 6.21349 16.5192C6.19847 16.5249 6.17956 16.5324 6.15712 16.5414C5.93152 16.6325 5.45081 16.8502 4.99227 17.188C4.64396 17.4446 4.37811 17.7178 4.20979 18L14.1898 18C14.0213 17.7182 13.7549 17.4449 13.4046 17.1879C12.9584 16.8605 12.4879 16.6437 12.2403 16.5435C12.2043 16.5289 12.1752 16.5177 12.1541 16.5098C11.5958 16.3671 11.179 16.2142 10.8632 16.0402L9.82857 15.47V12.7339L10.4461 12.1432C10.5814 12.0137 10.6534 11.8522 10.6897 11.6994L10.7907 11.2745L11.0597 10.9304C11.0755 10.9102 11.1061 10.8642 11.1469 10.7815C11.1881 10.6981 11.2226 10.6138 11.27 10.4951L11.2894 10.4467L11.2939 10.4353L11.311 10.3937L10.9727 9.73827L11.2272 8.91598Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/SliderIcon.tsx
import "react";
import { jsx as jsx112, jsxs as jsxs48 } from "react/jsx-runtime";
var SliderIcon = (props) => {
  return /* @__PURE__ */ jsx112(Icon, { ...props, children: /* @__PURE__ */ jsxs48(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx112("path", { d: "M19.4141 9.99995 16.707 12.7071 15.2927 11.2928 16.5856 9.99995 15.2927 8.70706 16.707 7.29285 19.4141 9.99995ZM7.29304 7.29282 4.58594 9.99992 7.29304 12.707 8.70726 11.2928 7.41436 9.99992 8.70726 8.70703 7.29304 7.29282Z" }),
        /* @__PURE__ */ jsx112(
          "path",
          {
            fillRule: "evenodd",
            d: "M2 16V4H22V16H2ZM4 6H20V14H4V6Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx112("path", { d: "M20 18H4V20H20V18Z" })
      ]
    }
  ) });
};

// src/components/Icons/SocialIcon.tsx
import "react";
import { jsx as jsx113, jsxs as jsxs49 } from "react/jsx-runtime";
var SocialIcon = (props) => {
  return /* @__PURE__ */ jsx113(Icon, { ...props, children: /* @__PURE__ */ jsxs49(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx113(
          "path",
          {
            fillRule: "evenodd",
            d: "M11.5688 16.4039C11.5335 16.3891 11.4842 16.3681 11.4228 16.3409C11.3002 16.2865 11.1287 16.2072 10.9244 16.1041C10.5184 15.8992 9.97035 15.5938 9.41596 15.1949C8.37749 14.4477 7 13.1442 7 11.3333C7 9.51192 8.45173 8 10.2857 8C10.9154 8 11.5023 8.18001 12 8.48931C12.4977 8.18001 13.0846 8 13.7143 8C15.5483 8 17 9.51192 17 11.3333C17 13.1442 15.6225 14.4477 14.584 15.1949C14.0297 15.5938 13.4816 15.8992 13.0756 16.1041C12.8713 16.2072 12.6998 16.2865 12.5772 16.3409C12.5158 16.3681 12.4665 16.3891 12.4312 16.4039L12 16.576L11.5688 16.4039ZM9 11.3333C9 10.5774 9.59497 10 10.2857 10C10.662 10 11.004 10.1669 11.2435 10.444L12 11.3189L12.7565 10.444C12.996 10.1669 13.338 10 13.7143 10C14.405 10 15 10.5774 15 11.3333C15 12.0998 14.3775 12.8796 13.416 13.5714C12.9703 13.8921 12.5184 14.1451 12.1744 14.3187C12.1121 14.3501 12.0537 14.3788 12 14.4046C11.9463 14.3788 11.8879 14.3501 11.8256 14.3187C11.4816 14.1451 11.0297 13.8921 10.584 13.5714C9.62251 12.8796 9 12.0998 9 11.3333Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx113(
          "path",
          {
            fillRule: "evenodd",
            d: "M2 8C2 5.79086 3.79086 4 6 4H18C20.2091 4 22 5.79086 22 8V20H6C3.79086 20 2 18.2091 2 16V8ZM6 6H18C19.1046 6 20 6.89543 20 8V18H6C4.89543 18 4 17.1046 4 16V8C4 6.89543 4.89543 6 6 6Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/SpacerIcon.tsx
import "react";
import { jsx as jsx114 } from "react/jsx-runtime";
var SpacerIcon = (props) => {
  return /* @__PURE__ */ jsx114(Icon, { ...props, children: /* @__PURE__ */ jsx114(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx114("path", { d: "M4 4V2H20V4H4ZM16.7072 9.29286 12.0001 4.58575 7.29297 9.29286 8.70718 10.7071 11 8.41426 11 15.5858 8.70703 13.2928 7.29282 14.707 11.9999 19.4141 16.707 14.707 15.2928 13.2928 13 15.5856 13 8.41411 15.293 10.7071 16.7072 9.29286ZM4 20V22H20V20H4Z" })
    }
  ) });
};

// src/components/Icons/StateIcon.tsx
import "react";
import { jsx as jsx115, jsxs as jsxs50 } from "react/jsx-runtime";
var StateIcon = (props) => {
  return /* @__PURE__ */ jsx115(Icon, { ...props, children: /* @__PURE__ */ jsxs50(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx115("path", { d: "M10 8C10 6.89543 10.8954 6 12 6 13.1046 6 14 6.89543 14 8 14 9.10457 13.1046 10 12 10 10.8954 10 10 9.10457 10 8ZM12 12C10.8954 12 10 12.8954 10 14 10 15.1046 10.8954 16 12 16 13.1046 16 14 15.1046 14 14 14 12.8954 13.1046 12 12 12Z" }),
        /* @__PURE__ */ jsx115(
          "path",
          {
            fillRule: "evenodd",
            d: "M6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V14C18 16.973 15.8377 19.441 13 19.917V20H16V22H8V20H11V19.917C8.16229 19.441 6 16.973 6 14V8ZM12 18C14.2091 18 16 16.2091 16 14V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8V14C8 16.2091 9.79086 18 12 18Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/SubtitleIcon.tsx
import "react";
import { jsx as jsx116, jsxs as jsxs51 } from "react/jsx-runtime";
var SubtitleIcon = (props) => {
  return /* @__PURE__ */ jsx116(Icon, { ...props, children: /* @__PURE__ */ jsxs51(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx116("path", { d: "M14 10H10V12H14V10Z" }),
        /* @__PURE__ */ jsx116(
          "path",
          {
            fillRule: "evenodd",
            d: "M6 4V20L12 15L18 20V4H6ZM16 6V15.7299L12 12.3966L8 15.7299V6H16Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/TableIcon.tsx
import "react";
import { jsx as jsx117 } from "react/jsx-runtime";
var TableIcon = (props) => {
  return /* @__PURE__ */ jsx117(Icon, { ...props, children: /* @__PURE__ */ jsx117(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx117(
        "path",
        {
          fillRule: "evenodd",
          d: "M3 3V21H21V3H3ZM11 5H5V11H11V5ZM13 5V11H19V5H13ZM11 13H5V19H11V13ZM13 19V13H19V19H13Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/TagIcon.tsx
import "react";
import { jsx as jsx118, jsxs as jsxs52 } from "react/jsx-runtime";
var TagIcon = (props) => {
  return /* @__PURE__ */ jsx118(Icon, { ...props, children: /* @__PURE__ */ jsxs52(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx118("path", { d: "M15 7C13.8954 7 13 7.89543 13 9C13 10.1046 13.8954 11 15 11C16.1046 11 17 10.1046 17 9C17 7.89543 16.1046 7 15 7Z" }),
        /* @__PURE__ */ jsx118(
          "path",
          {
            fillRule: "evenodd",
            d: "M12.6567 3C11.5959 3 10.5785 3.42143 9.82831 4.17157L3.82831 10.1716C2.26621 11.7337 2.26622 14.2663 3.82831 15.8284L8.17146 20.1716C9.73356 21.7337 12.2662 21.7337 13.8283 20.1716L19.8283 14.1716C20.5785 13.4214 20.9999 12.404 20.9999 11.3431V3H12.6567ZM12.6567 5H18.9999V11.3431C18.9999 11.8736 18.7892 12.3823 18.4141 12.7574L12.4141 18.7574C11.633 19.5384 10.3667 19.5384 9.58568 18.7574L5.24253 14.4142C4.46148 13.6332 4.46148 12.3668 5.24252 11.5858L11.2425 5.58579C11.6176 5.21071 12.1263 5 12.6567 5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/TextIcon.tsx
import "react";
import { jsx as jsx119 } from "react/jsx-runtime";
var TextIcon = (props) => {
  return /* @__PURE__ */ jsx119(Icon, { ...props, children: /* @__PURE__ */ jsx119(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx119("path", { d: "M5 3H19V7H17V5H13V19H15V21H9V19H11V5H7V7H5V3Z" })
    }
  ) });
};

// src/components/Icons/ThumbnailsIcon.tsx
import "react";
import { jsx as jsx120 } from "react/jsx-runtime";
var ThumbnailsIcon = (props) => {
  return /* @__PURE__ */ jsx120(Icon, { ...props, children: /* @__PURE__ */ jsx120(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx120(
        "path",
        {
          fillRule: "evenodd",
          d: "M3 11V3H11V11H3ZM5 5H9V9H5V5ZM13 11V3H21V11H13ZM15 5H19V9H15V5ZM3 13V21H11V13H3ZM9 15H5V19H9V15ZM13 21V13H21V21H13ZM15 15H19V19H15V15Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/TitleIcon.tsx
import "react";
import { jsx as jsx121, jsxs as jsxs53 } from "react/jsx-runtime";
var TitleIcon = (props) => {
  return /* @__PURE__ */ jsx121(Icon, { ...props, children: /* @__PURE__ */ jsxs53(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx121("path", { d: "M16 6H8V10H16V6Z" }),
        /* @__PURE__ */ jsx121(
          "path",
          {
            fillRule: "evenodd",
            d: "M4 2L4 22L12 15L20 22V2L4 2ZM18 17.5925L12 12.3425L6 17.5925V4H18V17.5925Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/TocIcon.tsx
import "react";
import { jsx as jsx122 } from "react/jsx-runtime";
var TocIcon = (props) => {
  return /* @__PURE__ */ jsx122(Icon, { ...props, children: /* @__PURE__ */ jsx122(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx122(
        "path",
        {
          fillRule: "evenodd",
          d: "M16 5H2V7H16V5ZM16 11H2V13H16V11ZM2 17H16V19H2V17ZM18 5H22V7H18V5ZM22 11H18V13H22V11ZM18 17H22V19H18V17Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/UndoIcon.tsx
import "react";
import { jsx as jsx123 } from "react/jsx-runtime";
var UndoIcon = (props) => {
  return /* @__PURE__ */ jsx123(Icon, { ...props, children: /* @__PURE__ */ jsx123(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx123(
        "path",
        {
          fillRule: "evenodd",
          d: "M6.25492 8.00006H9V10.0001H3V4.00006H5V6.34109C7.73532 2.94903 12.608 1.95877 16.5 4.20581C20.8046 6.69109 22.2795 12.1954 19.7942 16.5C17.3089 20.8047 11.8047 22.2796 7.50002 19.7943L8.50002 18.0623C11.8481 19.9952 16.1292 18.8481 18.0622 15.5C19.9952 12.152 18.848 7.87086 15.5 5.93786C12.3245 4.10448 8.30959 5.04193 6.25492 8.00006ZM5 7.9586L5.07181 8.00006H5V7.9586Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/UploadIcon.tsx
import "react";
import { jsx as jsx124, jsxs as jsxs54 } from "react/jsx-runtime";
var UploadIcon = (props) => {
  return /* @__PURE__ */ jsx124(Icon, { ...props, children: /* @__PURE__ */ jsxs54(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx124("path", { d: "M12.0001 2.58594L16.7072 7.29305L15.293 8.70726L13 6.41429L13 15.0001H11L11 6.41444L8.70718 8.70726L7.29297 7.29304L12.0001 2.58594Z" }),
        /* @__PURE__ */ jsx124("path", { d: "M17.917 13.0001H19.9381C19.979 13.3277 20 13.6615 20 14.0001C20 18.4184 16.4183 22.0001 12 22.0001C7.58172 22.0001 4 18.4184 4 14.0001C4 13.6615 4.02104 13.3277 4.06189 13.0001H6.08296C6.0284 13.3253 6 13.6594 6 14.0001C6 17.3138 8.68629 20.0001 12 20.0001C15.3137 20.0001 18 17.3138 18 14.0001C18 13.6594 17.9716 13.3253 17.917 13.0001Z" })
      ]
    }
  ) });
};

// src/components/Icons/UserIcon.tsx
import "react";
import { jsx as jsx125 } from "react/jsx-runtime";
var UserIcon = (props) => {
  return /* @__PURE__ */ jsx125(Icon, { ...props, children: /* @__PURE__ */ jsx125(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx125(
        "path",
        {
          fillRule: "evenodd",
          d: "M9.97976 4.51502C9.68686 4.71607 9.31513 5.06166 9.07718 5.62524C8.84412 6.17722 8.70057 7.02849 8.99966 8.31532L9.24544 9.10442L8.88905 9.82264C8.88154 9.83779 8.8762 9.85182 8.87214 9.86716C8.86424 9.89702 8.84715 9.98427 8.88655 10.1768C8.96381 10.5543 9.08395 10.7586 9.21651 10.9091L9.54138 11.278L9.65824 11.7555C9.71979 12.007 9.84643 12.2988 10.0997 12.5409L10.7157 13.1297L10.7214 15.5557L10.1319 16.1438C9.72447 16.5503 9.08883 16.9202 8.1148 17.1719C7.9382 17.2383 7.17938 17.5406 6.44379 18.0824C5.72516 18.6118 5.18275 19.251 5.03817 20L18.9618 20C18.8172 19.2515 18.2747 18.6123 17.5515 18.0818C17.1497 17.787 16.7318 17.5571 16.3916 17.3945C16.2239 17.3143 16.0812 17.2534 15.9771 17.2115C15.9155 17.1867 15.8694 17.1694 15.8417 17.1592C15.1518 16.9843 14.6681 16.804 14.3203 16.6124L13.2857 16.0421L13.2857 13.131L13.9032 12.5403C14.1615 12.2932 14.2881 11.9945 14.3486 11.7399L14.4496 11.315L14.7185 10.9709C14.7656 10.9107 14.8212 10.8214 14.882 10.6983C14.9431 10.5744 14.9927 10.4523 15.0518 10.3043L15.0758 10.2444L15.0804 10.233L15.1586 10.0413C15.1699 10.0141 15.1724 9.99919 15.173 9.99461C15.1737 9.98956 15.174 9.98464 15.1732 9.97724C15.1715 9.95988 15.1629 9.9175 15.1292 9.85229L14.754 9.12528L15.0172 8.27515C15.2095 7.44451 15.1934 6.87882 15.1128 6.48804C15.0328 6.10012 14.877 5.82372 14.6974 5.58192C14.5014 5.31817 14.2706 5.16655 14.0637 5.10343L13.5616 4.95025L13.1995 4.57024C12.9075 4.26384 12.5132 4 12.0223 4C11.522 4 10.6783 4.03512 9.97976 4.51502ZM16.9483 8.80019L16.9065 8.93507C17.158 9.42239 17.3072 10.08 17.0066 10.8062L16.9323 10.9883L16.9315 10.9905L16.9091 11.0464C16.7924 11.3383 16.607 11.8024 16.2944 12.2024C16.1734 12.7113 15.9003 13.3976 15.2857 13.9855L15.2857 14.8608C15.4287 14.9396 15.7412 15.0728 16.3737 15.2307L16.413 15.2405L16.4514 15.2535C16.4665 15.2586 16.4906 15.267 16.5228 15.2787C16.5749 15.2977 16.6481 15.3255 16.7387 15.3621C17.1587 15.5322 17.9513 15.8945 18.7346 16.4692C19.697 17.1753 20.8228 18.338 20.9811 20C20.9935 20.1301 21 20.2632 21 20.3994L21 22L3 22L3 20.3994C3 20.2632 3.00647 20.1301 3.01886 20C3.17716 18.3387 4.30182 17.1762 5.25763 16.4721C6.06171 15.8798 6.87182 15.5155 7.26012 15.3587C7.3793 15.3106 7.45874 15.282 7.48608 15.2723L7.53015 15.2568L7.57547 15.2454C8.32727 15.0568 8.62359 14.8235 8.71945 14.7278L8.71769 13.9866C8.11454 13.4101 7.83972 12.7381 7.71559 12.231C7.3269 11.7896 7.06613 11.2569 6.92716 10.5778C6.83905 10.1472 6.8367 9.74087 6.93871 9.35543C6.97966 9.20073 7.03446 9.06067 7.09749 8.93366L7.06921 8.84287L7.06122 8.80913C6.67033 7.15914 6.80885 5.85582 7.23468 4.84729C7.6572 3.84659 8.32539 3.22476 8.84794 2.86609C10.0885 2.01383 11.4809 2 12.0223 2C13.2876 2 14.1703 2.68986 14.6473 3.19048C15.3074 3.39187 15.8809 3.82154 16.3026 4.38899C16.6059 4.7971 16.9178 5.33805 17.0716 6.08416C17.2238 6.8224 17.2084 7.69809 16.9561 8.76694L16.9483 8.80019Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/Icons/VideoIcon.tsx
import "react";
import { jsx as jsx126, jsxs as jsxs55 } from "react/jsx-runtime";
var VideoIcon = (props) => {
  return /* @__PURE__ */ jsx126(Icon, { ...props, children: /* @__PURE__ */ jsxs55(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx126("path", { d: "M15 12L10 9V15L15 12Z" }),
        /* @__PURE__ */ jsx126(
          "path",
          {
            fillRule: "evenodd",
            d: "M2 20V4H22V20H2ZM4 6H20V18H4V6Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  ) });
};

// src/components/Icons/VoltoIcon.tsx
import "react";
import { jsx as jsx127, jsxs as jsxs56 } from "react/jsx-runtime";
var VoltoIcon = (props) => {
  return /* @__PURE__ */ jsx127(Icon, { ...props, children: /* @__PURE__ */ jsxs56(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx127("path", { d: "M13 12C13 10.8954 13.8954 10 15 10C16.1046 10 17 10.8954 17 12C17 13.1046 16.1046 14 15 14C13.8954 14 13 13.1046 13 12Z" }),
        /* @__PURE__ */ jsx127(
          "path",
          {
            fillRule: "evenodd",
            d: "M12 21.8C11.3538 21.9311 10.6849 22 10 22V2C10.6849 2 11.3538 2.06886 12 2.20004C16.5645 3.12658 20 7.16208 20 12C20 16.8379 16.5645 20.8734 12 21.8ZM12 19.748C15.4505 18.8599 18 15.7277 18 12C18 8.27232 15.4505 5.14012 12 4.25204V19.748Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx127("path", { d: "M7 10C5.89543 10 5 10.8954 5 12C5 13.1046 5.89543 14 7 14C8.10457 14 9 13.1046 9 12C9 10.8954 8.10457 10 7 10Z" })
      ]
    }
  ) });
};

// src/components/Icons/WindowedIcon.tsx
import "react";
import { jsx as jsx128 } from "react/jsx-runtime";
var WindowedIcon = (props) => {
  return /* @__PURE__ */ jsx128(Icon, { ...props, children: /* @__PURE__ */ jsx128(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx128("path", { d: "M9 9 3 9 3 7 7 7 7 3 9 3 9 9ZM9 15V21H7L7 17H3V15H9ZM21 15H15V21H17V17H21V15ZM15 9V3H17V7H21V9H15ZM12 10C10.8954 10 10 10.8954 10 12 10 13.1046 10.8954 14 12 14 13.1046 14 14 13.1046 14 12 14 10.8954 13.1046 10 12 10Z" })
    }
  ) });
};

// src/components/Icons/WorldIcon.tsx
import "react";
import { jsx as jsx129 } from "react/jsx-runtime";
var WorldIcon = (props) => {
  return /* @__PURE__ */ jsx129(Icon, { ...props, children: /* @__PURE__ */ jsx129(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ jsx129(
        "path",
        {
          fillRule: "evenodd",
          d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9.38254 19.562C8.93442 18.5917 8.57343 17.3767 8.33284 16H5.07026C6.02529 17.651 7.55338 18.929 9.38254 19.562ZM11.0285 18.3283C10.7671 17.6747 10.5403 16.8885 10.3667 16H13.6333C13.4597 16.8885 13.2329 17.6747 12.9715 18.3283C12.6653 19.0937 12.3508 19.5788 12.1039 19.8399C12.0635 19.8826 12.0289 19.9155 12 19.9407C11.9711 19.9155 11.9365 19.8826 11.8961 19.8399C11.6492 19.5788 11.3347 19.0937 11.0285 18.3283ZM10 12C10 12.6936 10.0306 13.3627 10.0872 14H13.9128C13.9694 13.3627 14 12.6936 14 12C14 11.3064 13.9694 10.6373 13.9128 10H10.0872C10.0306 10.6373 10 11.3064 10 12ZM8.08002 10C8.02754 10.6462 8 11.3151 8 12C8 12.6849 8.02754 13.3538 8.08002 14H4.25204C4.08751 13.3608 4 12.6906 4 12C4 11.3094 4.08751 10.6392 4.25204 10H8.08002ZM10.3667 8H13.6333C13.4597 7.11152 13.2329 6.32531 12.9715 5.67171C12.6653 4.90634 12.3508 4.42118 12.1039 4.16007C12.0635 4.11741 12.0289 4.08451 12 4.05929C11.9711 4.08451 11.9365 4.11741 11.8961 4.16007C11.6492 4.42118 11.3347 4.90634 11.0285 5.67171C10.7671 6.32531 10.5403 7.11152 10.3667 8ZM15.92 10C15.9725 10.6462 16 11.3151 16 12C16 12.6849 15.9725 13.3538 15.92 14H19.748C19.9125 13.3608 20 12.6906 20 12C20 11.3094 19.9125 10.6392 19.748 10H15.92ZM18.9297 8H15.6672C15.4266 6.62334 15.0656 5.40828 14.6175 4.43801C16.4466 5.07104 17.9747 6.34903 18.9297 8ZM8.33284 8H5.07026C6.02529 6.34903 7.55338 5.07104 9.38254 4.438C8.93442 5.40828 8.57343 6.62334 8.33284 8ZM14.6175 19.562C15.0656 18.5917 15.4266 17.3767 15.6672 16H18.9297C17.9747 17.651 16.4466 18.929 14.6175 19.562Z",
          clipRule: "evenodd"
        }
      )
    }
  ) });
};

// src/components/ListBox/ListBox.tsx
import "react";
import {
  ListBox as RACListBox,
  ListBoxItem as RACListBoxItem
} from "react-aria-components";
import { jsx as jsx130 } from "react/jsx-runtime";
function ListBox2({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx130(RACListBox, { ...props, children });
}
function ListBoxItem2(props) {
  return /* @__PURE__ */ jsx130(RACListBoxItem, { ...props });
}

// src/components/Menu/Menu.tsx
import "react";
import {
  Menu as RACMenu,
  MenuItem as RACMenuItem,
  MenuTrigger,
  Popover as Popover5
} from "react-aria-components";
import { jsx as jsx131, jsxs as jsxs57 } from "react/jsx-runtime";
function Menu({
  button,
  onPress,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsxs57(MenuTrigger, { ...props, children: [
    /* @__PURE__ */ jsx131(Button, { onPress, children: button }),
    /* @__PURE__ */ jsx131(Popover5, { children: /* @__PURE__ */ jsx131(RACMenu, { ...props, children }) })
  ] });
}
function MenuItem(props) {
  return /* @__PURE__ */ jsx131(RACMenuItem, { ...props });
}

// src/components/Meter/Meter.tsx
import "react";
import {
  Label as Label7,
  Meter as RACMeter
} from "react-aria-components";
import { Fragment as Fragment4, jsx as jsx132, jsxs as jsxs58 } from "react/jsx-runtime";
function Meter({ label, ...props }) {
  return /* @__PURE__ */ jsx132(RACMeter, { ...props, children: ({ percentage, valueText }) => /* @__PURE__ */ jsxs58(Fragment4, { children: [
    /* @__PURE__ */ jsx132(Label7, { children: label }),
    /* @__PURE__ */ jsx132("span", { className: "value", children: valueText }),
    /* @__PURE__ */ jsx132("div", { className: "bar", children: /* @__PURE__ */ jsx132("div", { className: "fill", style: { width: percentage + "%" } }) })
  ] }) });
}

// src/components/Modal/Modal.tsx
import "react";
import {
  Modal as RACModal
} from "react-aria-components";
import { jsx as jsx133 } from "react/jsx-runtime";
function Modal(props) {
  return /* @__PURE__ */ jsx133(RACModal, { ...props });
}

// src/components/NumberField/NumberField.tsx
import "react";
import {
  FieldError as FieldError7,
  Group as Group3,
  Input as Input3,
  Label as Label8,
  NumberField as RACNumberField,
  Text as Text9
} from "react-aria-components";
import { jsx as jsx134, jsxs as jsxs59 } from "react/jsx-runtime";
function NumberField({
  label,
  description,
  errorMessage,
  ...props
}) {
  return /* @__PURE__ */ jsxs59(RACNumberField, { ...props, children: [
    /* @__PURE__ */ jsx134(Label8, { children: label }),
    /* @__PURE__ */ jsxs59(Group3, { children: [
      /* @__PURE__ */ jsx134(Button, { slot: "decrement", children: /* @__PURE__ */ jsx134(DashIcon, { size: "XS" }) }),
      /* @__PURE__ */ jsx134(Input3, {}),
      /* @__PURE__ */ jsx134(Button, { slot: "increment", children: /* @__PURE__ */ jsx134(AddIcon, { size: "XS" }) })
    ] }),
    description && /* @__PURE__ */ jsx134(Text9, { slot: "description", children: description }),
    /* @__PURE__ */ jsx134(FieldError7, { children: errorMessage })
  ] });
}

// src/components/Popover/Popover.tsx
import "react";
import {
  OverlayArrow,
  Popover as RACPopover
} from "react-aria-components";
import { jsx as jsx135, jsxs as jsxs60 } from "react/jsx-runtime";
function Popover6({
  children,
  dialogAriaLabel,
  dialogAriaLabelledby,
  showArrow,
  ...props
}) {
  return /* @__PURE__ */ jsxs60(RACPopover, { ...props, children: [
    showArrow && /* @__PURE__ */ jsx135(OverlayArrow, { children: /* @__PURE__ */ jsx135("svg", { width: 12, height: 12, viewBox: "0 0 12 12", children: /* @__PURE__ */ jsx135("path", { d: "M0 0 L6 6 L12 0" }) }) }),
    /* @__PURE__ */ jsx135(
      Dialog4,
      {
        "aria-label": dialogAriaLabel,
        "aria-labelledby": dialogAriaLabelledby,
        children
      }
    )
  ] });
}

// src/components/ProgressBar/ProgressBar.tsx
import "react";
import {
  Label as Label9,
  ProgressBar as RACProgressBar
} from "react-aria-components";
import { Fragment as Fragment5, jsx as jsx136, jsxs as jsxs61 } from "react/jsx-runtime";
function ProgressBar({ label, ...props }) {
  return /* @__PURE__ */ jsx136(RACProgressBar, { ...props, children: ({ percentage, valueText }) => /* @__PURE__ */ jsxs61(Fragment5, { children: [
    /* @__PURE__ */ jsx136(Label9, { children: label }),
    /* @__PURE__ */ jsx136("span", { className: "value", children: valueText }),
    /* @__PURE__ */ jsx136("div", { className: "bar", children: /* @__PURE__ */ jsx136("div", { className: "fill", style: { width: percentage + "%" } }) })
  ] }) });
}

// src/components/RadioGroup/RadioGroup.tsx
import "react";
import {
  FieldError as FieldError8,
  Label as Label10,
  RadioGroup as RACRadioGroup,
  Text as Text10
} from "react-aria-components";
import { jsx as jsx137, jsxs as jsxs62 } from "react/jsx-runtime";
function RadioGroup({
  label,
  description,
  errorMessage,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsxs62(RACRadioGroup, { ...props, children: [
    /* @__PURE__ */ jsx137(Label10, { children: label }),
    children,
    description && /* @__PURE__ */ jsx137(Text10, { slot: "description", children: description }),
    /* @__PURE__ */ jsx137(FieldError8, { children: errorMessage })
  ] });
}

// src/components/RangeCalendar/RangeCalendar.tsx
import "react";
import {
  Button as Button8,
  CalendarCell as CalendarCell4,
  CalendarGrid as CalendarGrid4,
  Heading as Heading4,
  RangeCalendar as RACRangeCalendar,
  Text as Text11
} from "react-aria-components";
import { jsx as jsx138, jsxs as jsxs63 } from "react/jsx-runtime";
function RangeCalendar2({
  errorMessage,
  ...props
}) {
  return /* @__PURE__ */ jsxs63(RACRangeCalendar, { ...props, children: [
    /* @__PURE__ */ jsxs63("header", { children: [
      /* @__PURE__ */ jsx138(Button8, { slot: "previous", children: "\u25C0" }),
      /* @__PURE__ */ jsx138(Heading4, {}),
      /* @__PURE__ */ jsx138(Button8, { slot: "next", children: "\u25B6" })
    ] }),
    /* @__PURE__ */ jsx138(CalendarGrid4, { children: (date) => /* @__PURE__ */ jsx138(CalendarCell4, { date }) }),
    errorMessage && /* @__PURE__ */ jsx138(Text11, { slot: "errorMessage", children: errorMessage })
  ] });
}

// src/components/SearchField/SearchField.tsx
import "react";
import {
  Button as Button9,
  FieldError as FieldError9,
  Input as Input4,
  Label as Label11,
  SearchField as RACSearchField,
  Text as Text12
} from "react-aria-components";
import { jsx as jsx139, jsxs as jsxs64 } from "react/jsx-runtime";
function SearchField({
  label,
  description,
  errorMessage,
  ...props
}) {
  return /* @__PURE__ */ jsxs64(RACSearchField, { ...props, children: [
    /* @__PURE__ */ jsx139(Label11, { children: label }),
    /* @__PURE__ */ jsx139(Input4, {}),
    /* @__PURE__ */ jsx139(Button9, { children: "\u2715" }),
    description && /* @__PURE__ */ jsx139(Text12, { slot: "description", children: description }),
    /* @__PURE__ */ jsx139(FieldError9, { children: errorMessage })
  ] });
}

// src/components/Select/Select.tsx
import "react";
import {
  Button as Button10,
  FieldError as FieldError10,
  Label as Label12,
  ListBox as ListBox3,
  ListBoxItem as ListBoxItem3,
  Popover as Popover7,
  PopoverContext,
  Select as RACSelect,
  SelectValue,
  Text as Text13,
  useContextProps
} from "react-aria-components";
import { Fragment as Fragment6, jsx as jsx140, jsxs as jsxs65 } from "react/jsx-runtime";
function Select({
  label,
  description,
  errorMessage,
  children,
  items,
  ...props
}) {
  const [popoverProps] = useContextProps({}, null, PopoverContext);
  return /* @__PURE__ */ jsx140(RACSelect, { ...props, children: ({ isOpen }) => /* @__PURE__ */ jsxs65(Fragment6, { children: [
    /* @__PURE__ */ jsx140(Label12, { children: label }),
    /* @__PURE__ */ jsxs65(Button10, { children: [
      /* @__PURE__ */ jsx140(SelectValue, {}),
      /* @__PURE__ */ jsx140("span", { "aria-hidden": "true", style: { display: "flex" }, children: isOpen ? /* @__PURE__ */ jsx140(ChevronupIcon, {}) : /* @__PURE__ */ jsx140(ChevrondownIcon, {}) })
    ] }),
    description && /* @__PURE__ */ jsx140(Text13, { slot: "description", children: description }),
    /* @__PURE__ */ jsx140(FieldError10, { children: errorMessage }),
    /* @__PURE__ */ jsx140(Popover7, { ...popoverProps, children: children ? /* @__PURE__ */ jsx140(ListBox3, { items, children }) : /* @__PURE__ */ jsx140(ListBox3, { items, children: (item) => /* @__PURE__ */ jsx140(SelectItem, { id: item.label, children: item.value }) }) })
  ] }) });
}
function SelectItem(props) {
  return /* @__PURE__ */ jsx140(ListBoxItem3, { ...props });
}

// src/components/Slider/Slider.tsx
import "react";
import {
  Label as Label13,
  Slider as RACSlider,
  SliderOutput as SliderOutput2,
  SliderThumb,
  SliderTrack as SliderTrack2
} from "react-aria-components";
import { jsx as jsx141, jsxs as jsxs66 } from "react/jsx-runtime";
function Slider({
  label,
  thumbLabels,
  ...props
}) {
  return /* @__PURE__ */ jsxs66(RACSlider, { ...props, children: [
    /* @__PURE__ */ jsx141(Label13, { children: label }),
    /* @__PURE__ */ jsx141(SliderOutput2, { children: ({ state }) => state.values.map((_, i) => state.getThumbValueLabel(i)).join(" \u2013 ") }),
    /* @__PURE__ */ jsx141(SliderTrack2, { children: ({ state }) => state.values.map((_, i) => /* @__PURE__ */ jsx141(SliderThumb, { index: i, "aria-label": thumbLabels?.[i] }, i)) })
  ] });
}

// src/components/Switch/Switch.tsx
import "react";
import {
  Switch as RACSwitch
} from "react-aria-components";
import { jsx as jsx142, jsxs as jsxs67 } from "react/jsx-runtime";
function Switch({ children, ...props }) {
  return /* @__PURE__ */ jsxs67(RACSwitch, { ...props, children: [
    /* @__PURE__ */ jsx142("div", { className: "indicator" }),
    children
  ] });
}

// src/components/Table/Table.tsx
import "react";
import {
  ResizableTableContainer,
  ColumnResizer,
  Table as RACTable,
  TableBody,
  Cell as Cell2
} from "react-aria-components";

// src/components/Table/TableHeader.tsx
import "react";
import {
  TableHeader as RACTableHeader,
  useTableOptions,
  Collection
} from "react-aria-components";

// src/components/Table/Column.tsx
import "react";
import { Column as RACColumn } from "react-aria-components";
import { Fragment as Fragment7, jsx as jsx143, jsxs as jsxs68 } from "react/jsx-runtime";
function Column(props) {
  return /* @__PURE__ */ jsx143(RACColumn, { ...props, children: ({ allowsSorting, sortDirection }) => /* @__PURE__ */ jsxs68(Fragment7, { children: [
    props.children,
    allowsSorting && /* @__PURE__ */ jsx143("span", { "aria-hidden": "true", className: "sort-indicator", children: sortDirection === "ascending" ? "\u25B2" : "\u25BC" })
  ] }) });
}

// src/components/Table/TableHeader.tsx
import { jsx as jsx144, jsxs as jsxs69 } from "react/jsx-runtime";
function TableHeader({
  columns,
  children,
  dragColumnHeader
}) {
  let { selectionBehavior, selectionMode, allowsDragging } = useTableOptions();
  return /* @__PURE__ */ jsxs69(RACTableHeader, { children: [
    allowsDragging && /* @__PURE__ */ jsx144(Column, { className: "react-aria-Column drag-column-header", children: dragColumnHeader }),
    selectionBehavior === "toggle" && /* @__PURE__ */ jsx144(Column, { children: selectionMode === "multiple" && /* @__PURE__ */ jsx144(Checkbox, { slot: "selection" }) }),
    /* @__PURE__ */ jsx144(Collection, { items: columns, children })
  ] });
}

// src/components/Table/Row.tsx
import "react";
import {
  Row as RACRow,
  Cell,
  Collection as Collection2,
  useTableOptions as useTableOptions2,
  Button as Button11
} from "react-aria-components";
import { jsx as jsx145, jsxs as jsxs70 } from "react/jsx-runtime";
function Row({
  id,
  columns,
  children,
  ...otherProps
}) {
  let { selectionBehavior, allowsDragging } = useTableOptions2();
  return /* @__PURE__ */ jsxs70(RACRow, { id, ...otherProps, children: [
    allowsDragging && /* @__PURE__ */ jsx145(Cell, { className: "react-aria-Cell drag-cell", children: /* @__PURE__ */ jsx145(Button11, { slot: "drag", children: /* @__PURE__ */ jsx145(DraggableIcon, {}) }) }),
    selectionBehavior === "toggle" && /* @__PURE__ */ jsx145(Cell, { children: /* @__PURE__ */ jsx145(Checkbox, { slot: "selection" }) }),
    /* @__PURE__ */ jsx145(Collection2, { items: columns, children })
  ] });
}

// src/components/Table/Table.tsx
import { jsx as jsx146, jsxs as jsxs71 } from "react/jsx-runtime";
function Table({
  columns,
  rows,
  resizableColumns,
  dragColumnHeader,
  ...otherProps
}) {
  let table = null;
  if (Array.isArray(columns) && Array.isArray(rows)) {
    table = /* @__PURE__ */ jsxs71(RACTable, { ...otherProps, children: [
      /* @__PURE__ */ jsx146(TableHeader, { columns, dragColumnHeader, children: (column) => /* @__PURE__ */ jsxs71(Column, { isRowHeader: column.isRowHeader, children: [
        resizableColumns && /* @__PURE__ */ jsxs71("div", { className: "flex-wrapper", children: [
          /* @__PURE__ */ jsx146("span", { tabIndex: -1, className: "column-name", children: column.name }),
          /* @__PURE__ */ jsx146(ColumnResizer, {})
        ] }),
        !resizableColumns && column.name
      ] }) }),
      /* @__PURE__ */ jsx146(TableBody, { items: rows, children: (item) => /* @__PURE__ */ jsx146(Row, { columns, textValue: item.textValue, children: (column) => /* @__PURE__ */ jsx146(Cell2, { children: item[column.id] }) }) })
    ] });
  } else {
    table = /* @__PURE__ */ jsx146(RACTable, { ...otherProps });
    if (Array.isArray(columns)) {
      console.warn("The Table component was given columns but no rows");
    } else if (Array.isArray(rows)) {
      console.warn("The Table component was given rows but no columns");
    }
  }
  if (resizableColumns) {
    return /* @__PURE__ */ jsx146(ResizableTableContainer, { children: table });
  } else {
    return table;
  }
}

// src/components/Tabs/Tabs.tsx
import "react";
import { Tabs as RACTabs } from "react-aria-components";
import { jsx as jsx147 } from "react/jsx-runtime";
function Tabs(props) {
  return /* @__PURE__ */ jsx147(RACTabs, { ...props });
}

// src/components/TagGroup/TagGroup.tsx
import "react";
import {
  Button as Button12,
  Label as Label14,
  Tag as RACTag,
  TagGroup as RACTagGroup,
  TagList,
  Text as Text14
} from "react-aria-components";
import { Fragment as Fragment8, jsx as jsx148, jsxs as jsxs72 } from "react/jsx-runtime";
function TagGroup({
  label,
  description,
  errorMessage,
  items,
  children,
  renderEmptyState,
  ...props
}) {
  return /* @__PURE__ */ jsxs72(RACTagGroup, { ...props, children: [
    /* @__PURE__ */ jsx148(Label14, { children: label }),
    /* @__PURE__ */ jsx148(TagList, { items, renderEmptyState, children }),
    description && /* @__PURE__ */ jsx148(Text14, { slot: "description", children: description }),
    errorMessage && /* @__PURE__ */ jsx148(Text14, { slot: "errorMessage", children: errorMessage })
  ] });
}
function Tag({ children, ...props }) {
  let textValue = typeof children === "string" ? children : void 0;
  return /* @__PURE__ */ jsx148(RACTag, { textValue, ...props, children: ({ allowsRemoving }) => /* @__PURE__ */ jsxs72(Fragment8, { children: [
    children,
    allowsRemoving && /* @__PURE__ */ jsx148(Button12, { slot: "remove", children: "\u24E7" })
  ] }) });
}

// src/components/TextAreaField/TextAreaField.tsx
import "react";
import {
  FieldError as FieldError11,
  TextArea,
  Label as Label15,
  Text as Text15,
  TextField as RACTextField
} from "react-aria-components";
import { jsx as jsx149, jsxs as jsxs73 } from "react/jsx-runtime";
function TextAreaField({
  label,
  description,
  errorMessage,
  ...props
}) {
  return /* @__PURE__ */ jsxs73(RACTextField, { ...props, children: [
    /* @__PURE__ */ jsx149(Label15, { children: label }),
    /* @__PURE__ */ jsx149(TextArea, {}),
    description && /* @__PURE__ */ jsx149(Text15, { slot: "description", children: description }),
    /* @__PURE__ */ jsx149(FieldError11, { children: errorMessage })
  ] });
}

// src/components/TextField/TextField.tsx
import "react";
import {
  FieldError as FieldError12,
  Input as Input5,
  Label as Label16,
  Text as Text16,
  TextField as RACTextField2
} from "react-aria-components";
import { jsx as jsx150, jsxs as jsxs74 } from "react/jsx-runtime";
function TextField({
  label,
  description,
  errorMessage,
  ...props
}) {
  return /* @__PURE__ */ jsxs74(RACTextField2, { ...props, children: [
    /* @__PURE__ */ jsx150(Label16, { children: label }),
    /* @__PURE__ */ jsx150(Input5, {}),
    description && /* @__PURE__ */ jsx150(Text16, { slot: "description", children: description }),
    /* @__PURE__ */ jsx150(FieldError12, { children: errorMessage })
  ] });
}

// src/components/TimeField/TimeField.tsx
import "react";
import {
  DateInput as DateInput4,
  DateSegment as DateSegment4,
  FieldError as FieldError13,
  Label as Label17,
  Text as Text17,
  TimeField as RACTimeField
} from "react-aria-components";
import { jsx as jsx151, jsxs as jsxs75 } from "react/jsx-runtime";
function TimeField({
  label,
  description,
  errorMessage,
  ...props
}) {
  return /* @__PURE__ */ jsxs75(RACTimeField, { ...props, children: [
    /* @__PURE__ */ jsx151(Label17, { children: label }),
    /* @__PURE__ */ jsx151(DateInput4, { children: (segment) => /* @__PURE__ */ jsx151(DateSegment4, { segment }) }),
    description && /* @__PURE__ */ jsx151(Text17, { slot: "description", children: description }),
    /* @__PURE__ */ jsx151(FieldError13, { children: errorMessage })
  ] });
}

// src/components/Toast/Toast.tsx
import "react";
import { Fragment as Fragment9, jsx as jsx152, jsxs as jsxs76 } from "react/jsx-runtime";
function Toast(props) {
  function getIcon(props2) {
    if (props2.info) {
      return InfoIcon;
    } else if (props2.success) {
      return CheckboxIcon;
    } else if (props2.error) {
      return CloseIcon;
    } else if (props2.warning) {
      return CloseIcon;
    } else {
      return CheckboxIcon;
    }
  }
  const { title, content } = props;
  const Icon2 = getIcon(props);
  return /* @__PURE__ */ jsxs76(Fragment9, { children: [
    /* @__PURE__ */ jsx152(Icon2, { size: "S" }),
    /* @__PURE__ */ jsxs76("div", { className: "toast-inner-content", children: [
      title && /* @__PURE__ */ jsx152("h4", { children: title }),
      /* @__PURE__ */ jsx152("p", { children: content })
    ] })
  ] });
}

// src/components/ToggleButton/ToggleButton.tsx
import "react";
import {
  ToggleButton as RACToggleButton
} from "react-aria-components";
import { jsx as jsx153 } from "react/jsx-runtime";
function ToggleButton(props) {
  return /* @__PURE__ */ jsx153(RACToggleButton, { ...props });
}

// src/components/Toolbar/Toolbar.tsx
import "react";
import {
  Toolbar as RACToolbar2
} from "react-aria-components";
import { jsx as jsx154 } from "react/jsx-runtime";
function Toolbar(props) {
  return /* @__PURE__ */ jsx154(RACToolbar2, { ...props });
}

// src/components/Tooltip/Tooltip.tsx
import "react";
import {
  OverlayArrow as OverlayArrow2,
  Tooltip as RACTooltip
} from "react-aria-components";
import { jsx as jsx155, jsxs as jsxs77 } from "react/jsx-runtime";
function Tooltip({ children, ...props }) {
  return /* @__PURE__ */ jsxs77(RACTooltip, { ...props, children: [
    /* @__PURE__ */ jsx155(OverlayArrow2, { children: /* @__PURE__ */ jsx155("svg", { width: 8, height: 8, viewBox: "0 0 8 8", children: /* @__PURE__ */ jsx155("path", { d: "M0 0 L4 4 L8 0" }) }) }),
    children
  ] });
}

// src/views/RenderBlocks/RenderBlocks.tsx
import { Fragment as Fragment11 } from "react";

// src/helpers/blocks.ts
function hasBlocksData(content) {
  return Object.keys(content).find(
    (key) => key !== "volto.blocks" && key.endsWith("blocks")
  ) !== void 0;
}

// src/views/RenderBlocks/DefaultBlockView.tsx
import "react";
import { Fragment as Fragment10, jsx as jsx156 } from "react/jsx-runtime";
var DefaultBlockView = () => {
  return /* @__PURE__ */ jsx156(Fragment10, { children: "This block has no view assigned" });
};

// src/views/RenderBlocks/RenderBlocks.tsx
import { jsx as jsx157, jsxs as jsxs78 } from "react/jsx-runtime";
var RenderBlocks = (props) => {
  const { blocksConfig, content, pathname, metadata } = props;
  const CustomTag = props.as || Fragment11;
  return hasBlocksData(content) ? /* @__PURE__ */ jsx157(CustomTag, { children: content.blocks_layout.items.map((block) => {
    const blockData = content.blocks?.[block];
    const blockType = blockData?.["@type"];
    const Block = blocksConfig[blockType]?.view || DefaultBlockView;
    return Block ? (
      // @ts-ignore It's ok to pass the blockData as is
      /* @__PURE__ */ jsx157(
        Block,
        {
          id: block,
          metadata,
          properties: content,
          data: blockData,
          path: pathname || "",
          blocksConfig
        },
        block
      )
    ) : blockData ? /* @__PURE__ */ jsxs78("div", { children: [
      "Unknown block found: ",
      blockType
    ] }, block) : /* @__PURE__ */ jsx157("div", { children: "Invalid Block" }, block);
  }) }) : "";
};

// src/components/quanta/TextField/TextField.tsx
import "react";
import { TextFieldContext } from "react-aria-components";
import { jsx as jsx158 } from "react/jsx-runtime";
function QuantaTextField(props) {
  return /* @__PURE__ */ jsx158(TextFieldContext.Provider, { value: { className: "q react-aria-TextField" }, children: /* @__PURE__ */ jsx158(TextField, { ...props }) });
}

// src/components/quanta/TextAreaField/TextAreaField.tsx
import "react";
import { TextFieldContext as TextFieldContext2 } from "react-aria-components";
import { jsx as jsx159 } from "react/jsx-runtime";
function QuantaTextAreaField(props) {
  return /* @__PURE__ */ jsx159(
    TextFieldContext2.Provider,
    {
      value: { className: "q react-aria-TextAreaField" },
      children: /* @__PURE__ */ jsx159(TextAreaField, { ...props })
    }
  );
}

// src/components/quanta/Select/Select.tsx
import "react";
import { SelectContext, PopoverContext as PopoverContext2 } from "react-aria-components";
import { jsx as jsx160 } from "react/jsx-runtime";
function QuantaSelect(props) {
  return /* @__PURE__ */ jsx160(SelectContext.Provider, { value: { className: "q react-aria-Select" }, children: /* @__PURE__ */ jsx160(PopoverContext2.Provider, { value: { className: "q react-aria-Popover" }, children: /* @__PURE__ */ jsx160(Select, { ...props }) }) });
}
export {
  AddIcon,
  AligncenterIcon,
  AlignleftIcon,
  AlignrightIcon,
  ArchiveIcon,
  ArrowdownIcon,
  ArrowleftIcon,
  ArrowrightIcon,
  ArrowtoprightIcon,
  ArrowupIcon,
  AttachmentIcon,
  AutomatedcontentIcon,
  BackgroundIcon,
  BinIcon,
  BlindIcon,
  BlockToolbar,
  BoldIcon,
  Breadcrumbs,
  Button,
  Calendar,
  CalendarIcon,
  Checkbox,
  CheckboxField,
  CheckboxGroup,
  CheckboxIcon,
  ChevrondownIcon,
  ChevronleftIcon,
  ChevronrightIcon,
  ChevronupIcon,
  CloseIcon,
  CodeIcon,
  CollectionIcon,
  ColorArea,
  ColorField,
  ColorPicker,
  ColorSlider,
  ColorSwatch,
  ColorSwatchPicker,
  ColorWheel,
  Column,
  ColumnafterIcon,
  ColumnbeforeIcon,
  ColumndeleteIcon,
  ColumnsIcon,
  ComboBox,
  ComboBoxItem,
  Container,
  CopyIcon,
  CutIcon,
  DashIcon,
  DateField,
  DatePicker,
  DateRangePicker,
  DefaultBlockView,
  Dialog4 as Dialog,
  Disclosure,
  DisclosureGroup,
  DiscussionIcon,
  DraggableIcon,
  EditIcon,
  EyeIcon,
  FilterIcon,
  FolderIcon,
  FooterIcon,
  ForegroundIcon,
  Form,
  FullscreenIcon,
  GridList,
  GridListItem,
  HighlightIcon,
  HistoryIcon,
  HomeIcon2 as HomeIcon,
  Icon,
  ImageIcon,
  ImagefitIcon,
  ImagefullIcon,
  ImageleftIcon,
  ImagerightIcon,
  InfoIcon,
  ItalicIcon,
  LanguageIcon,
  LeadingIcon,
  LeadingimageIcon,
  Link,
  LinkIcon,
  ListBox2 as ListBox,
  ListBoxItem2 as ListBoxItem,
  ListIcon,
  ListnumbersIcon,
  MailIcon,
  MandatoryIcon,
  MapIcon,
  Menu,
  MenuIcon,
  MenuItem,
  MergedIcon,
  Meter,
  Modal,
  MoreoptionsIcon,
  NavigationIcon,
  NewsIcon,
  NumberField,
  OutIcon,
  PageIcon,
  ParagraphIcon,
  PasteIcon,
  PauseIcon,
  PencilIcon,
  PlayIcon,
  Popover6 as Popover,
  ProgressBar,
  PropertiesIcon,
  QuantaSelect,
  QuantaTextAreaField,
  QuantaTextField,
  QuotesIcon,
  RadioGroup,
  RadiobuttonIcon,
  RangeCalendar2 as RangeCalendar,
  RedoIcon,
  RenameIcon,
  RenderBlocks,
  ReverseIcon,
  ReviewIcon,
  Row,
  RowafterIcon,
  RowbeforeIcon,
  RowdeleteIcon,
  SearchField,
  SearchIcon,
  SecurityIcon,
  Select,
  SelectItem,
  SettingsIcon,
  ShareIcon,
  Slider,
  SliderIcon,
  SocialIcon,
  SpacerIcon,
  StateIcon,
  SubtitleIcon,
  Switch,
  Table,
  TableHeader,
  TableIcon,
  Tabs,
  Tag,
  TagGroup,
  TagIcon,
  TextAreaField,
  TextField,
  TextIcon,
  ThumbnailsIcon,
  TimeField,
  TitleIcon,
  Toast,
  TocIcon,
  ToggleButton,
  Toolbar,
  Tooltip,
  UndoIcon,
  UploadIcon,
  UserIcon,
  VideoIcon,
  VoltoIcon,
  WindowedIcon,
  WorldIcon
};
